// 'use client';
// import React, { useCallback, useEffect, useMemo, useState } from 'react';
// import {
//   Box,
//   Flex,
//   Text,
//   Heading,
//   useColorModeValue,
//   Badge,
//   Table,
//   Thead,
//   Tbody,
//   Tr,
//   Th,
//   Td,
//   Image,
//   VStack,
//   HStack,
//   Icon,
//   Spinner,
//   Divider,
//   Card,
//   CardBody,
//   CardHeader,
//   Modal,
//   ModalOverlay,
//   ModalContent,
//   ModalHeader,
//   ModalCloseButton,
//   ModalBody,
//   Button,
//   Wrap,
//   WrapItem,
//   Input,
//   Select,
// } from '@chakra-ui/react';
// import {
//   MdCheckCircle,
//   MdSchool,
//   MdOutlineQuiz,
//   MdChevronLeft,
//   MdChevronRight,
//   MdArrowBack,
// } from 'react-icons/md';
// import axios from 'axios';
// import DOMPurify from 'dompurify';

// import { useLocation, useNavigate } from 'react-router-dom';

// export default function MCQList({ mode = 'all' }) {
//   const bgCard = useColorModeValue('white', 'gray.800');
//   const bgHover = useColorModeValue('gray.50', 'gray.700');
//   const borderColor = useColorModeValue('gray.200', 'gray.600');
//   const secondaryText = useColorModeValue('gray.600', 'gray.400');
//   const accentColor = useColorModeValue('purple.600', 'purple.300');
//   const headerBg = useColorModeValue('purple.50', 'gray.800');
//   const correctOptionBgColor = useColorModeValue('green.50', 'green.900');
//   const tableBg = useColorModeValue('gray.100', 'gray.700');
//   // Additional color modes for conditional sections
//   const addMcqContainerBg = useColorModeValue('white', 'gray.700');
//   const addMcqInputBg = useColorModeValue('white', 'gray.600');
//   const paginationBoxBg = useColorModeValue('white', 'gray.700');
//   const optionBoxDefaultBg = useColorModeValue('gray.50', 'gray.700');
//   const explanationBoxBg = useColorModeValue('yellow.50', 'yellow.900');
//   const explanationBorderColor = useColorModeValue('yellow.200', 'yellow.700');

//   const rawBaseUrl = process.env.REACT_APP_BASE_URL || 'http://localhost:4000';
//   const baseUrl = rawBaseUrl.endsWith('/')
//     ? rawBaseUrl.slice(0, -1)
//     : rawBaseUrl;

//   const token = localStorage.getItem('token') || '';
//   const axiosConfig = useMemo(
//     () => ({ headers: { Authorization: `Bearer ${token}` } }),
//     [token],
//   );

//   const [testsWithMcqs, setTestsWithMcqs] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [expandedTestId, setExpandedTestId] = useState(null);
//   const [expandedChapterKey, setExpandedChapterKey] = useState(null);
//   const [selectedMcq, setSelectedMcq] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [error, setError] = useState('');
//   const [mcqIdInput, setMcqIdInput] = useState('');
//   const [addingMcq, setAddingMcq] = useState(false);
//   const [page, setPage] = useState(1);
//   const [chapters, setChapters] = useState([]);
//   const [chaptersLoading, setChaptersLoading] = useState(false);
//   const [chaptersError, setChaptersError] = useState('');
//   const [selectedChapterId, setSelectedChapterId] = useState('');
//   const [totalPages, setTotalPages] = useState(1);
//   const [totalMcqCount, setTotalMcqCount] = useState(0);

//   const limit = 20;

//   const location = useLocation();
//   const navigate = useNavigate();
//   const isQTestListPage = location.pathname === '/admin/mcqs-q-test-list';
//   // 🔧 CHANGE 1 — safer testId
//   const testIdFromList = useMemo(() => {
//     return location.state?.testId ?? null;
//   }, [location.state]);
//   const hasActiveChapterFilter = isQTestListPage && Boolean(selectedChapterId);

//   const fetchChapters = useCallback(async () => {
//     if (!isQTestListPage) return;

//     setChaptersLoading(true);
//     setChaptersError('');

//     try {
//       const res = await axios.get(`${baseUrl}/api/admin/chapters`, axiosConfig);
//       setChapters(res.data?.data ?? []);
//     } catch (err) {
//       console.error('Failed to fetch chapters:', err);
//       setChaptersError(
//         err?.response?.data?.message || 'Failed to load chapters.',
//       );
//     } finally {
//       setChaptersLoading(false);
//     }
//   }, [axiosConfig, baseUrl, isQTestListPage]);

//   // 🔧 CHANGE 2 — include mode + testId deps
//   const fetchMcqsTestWise = useCallback(async () => {
//     setLoading(true);
//     setError('');
//     try {
//       const params = new URLSearchParams({
//         page: String(page),
//         limit: String(limit),
//       });

//       /**
//        * STRICT FILTERING LOGIC FOR MCQ LISTING
//        *
//        * Mode 'manual': testId=null → Only manual MCQs
//        * Mode 'exam': testMode=exam → Only exam-mode test MCQs
//        * Mode 'regular': testMode=regular → Only Q-Test regular-mode MCQs
//        * testIdFromList: ?testId={id} → Only specific test's MCQs
//        *
//        * ⚠️ CRITICAL: Different MCQ types must NEVER mix
//        */

//       if (mode === 'manual') {
//         // Manual MCQs only (no test association)
//         params.set('testId', 'null');
//       } else if (testIdFromList) {
//         // Specific test's MCQs only
//         params.set('testId', testIdFromList);
//       } else if (mode === 'exam') {
//         // Exam mode tests only - NO manual MCQs, NO regular mode MCQs
//         params.set('testMode', 'exam');
//       } else if (mode === 'regular') {
//         // Q-Test (regular mode) only - NO manual MCQs, NO exam mode MCQs
//         params.set('testMode', 'regular');
//       }

//       if (isQTestListPage && selectedChapterId) {
//         params.set('chapterId', selectedChapterId);
//       }

//       const url = `${baseUrl}/api/admin/mcqs?${params.toString()}`;
//       console.log('Fetching MCQ URL:', url);
//       const res = await axios.get(url, axiosConfig);
//       const data = res.data?.data ?? [];
//       const pagination = res.data?.pagination || {};

//       if (res.data?.format === 'test-wise-grouped' && Array.isArray(data)) {
//         setTestsWithMcqs(data);

//         // Set pagination info from response
//         setTotalPages(pagination.totalPages || 1);
//         setTotalMcqCount(pagination.total || 0);

//         if (data.length === 1) {
//           setExpandedTestId(data[0].testId ?? 'manual');
//         }
//       } else {
//         setTestsWithMcqs([]);
//         setTotalPages(1);
//         setTotalMcqCount(0);
//       }
//     } catch (err) {
//       console.error('Failed to fetch MCQs:', err);
//       setTestsWithMcqs([]);
//       setTotalPages(1);
//       setTotalMcqCount(0);
//       setError(
//         err?.response?.data?.message ||
//           'Failed to fetch MCQs. Please try again.',
//       );
//     } finally {
//       setLoading(false);
//     }
//   }, [
//     baseUrl,
//     axiosConfig,
//     isQTestListPage,
//     testIdFromList,
//     mode,
//     selectedChapterId,
//     page,
//     limit,
//   ]);

//   // 🔧 CHANGE 3 — refetch on route change
//   useEffect(() => {
//     setExpandedTestId(null);
//     setExpandedChapterKey(null);
//     setPage(1); // Reset page when route changes
//     setSelectedChapterId('');
//     setChapters([]);
//     setChaptersError('');
//     setTestsWithMcqs([]);
//     setTotalPages(1);
//     setTotalMcqCount(0);
//     setError('');
//   }, [location.key]);

//   // 🔧 CHANGE 4 — load chapters on the Q-Bank page
//   useEffect(() => {
//     if (!isQTestListPage) return;
//     fetchChapters();
//   }, [fetchChapters, isQTestListPage, location.key]);

//   // 🔧 CHANGE 5 — refetch when page changes
//   useEffect(() => {
//     fetchMcqsTestWise();
//   }, [page, fetchMcqsTestWise, location.key]);

//   const getDifficultyColor = (diff) => {
//     if (diff === 'easy') return 'green';
//     if (diff === 'medium') return 'yellow';
//     if (diff === 'hard') return 'red';
//     return 'gray';
//   };

//   const getImageUrl = (path) => {
//     if (!path) return '';
//     if (path.startsWith('http')) return path;
//     const cleanPath = path.startsWith('/') ? path.slice(1) : path;
//     return `${baseUrl}/${cleanPath}`;
//   };

//   const openModal = (mcq) => {
//     setSelectedMcq(mcq);
//     setIsModalOpen(true);
//   };

//   const closeModal = () => {
//     setSelectedMcq(null);
//     setIsModalOpen(false);
//   };
//   const handleDeleteMcq = async (mcqId) => {
//     if (!window.confirm('Are you sure you want to delete this MCQ?')) return;

//     try {
//       await axios.delete(`${baseUrl}/api/admin/mcqs/${mcqId}`, axiosConfig);

//       setPage(1); // Reset to first page
//       fetchMcqsTestWise(); // refresh list
//     } catch (err) {
//       console.error(err);
//       alert(err.response?.data?.message || 'Failed to delete MCQ');
//     }
//   };

//   const handleAddMcqToTest = async () => {
//     if (!mcqIdInput.trim() || !testIdFromList) {
//       alert('Invalid MCQ ID');
//       return;
//     }

//     try {
//       setAddingMcq(true);

//       await axios.post(
//         `${baseUrl}/api/admin/tests/${testIdFromList}/add-mcq-by-codon`,
//         { codonId: mcqIdInput.trim() },
//         axiosConfig,
//       );

//       setMcqIdInput('');
//       setPage(1); // Reset to first page
//       fetchMcqsTestWise(); // refresh list
//     } catch (err) {
//       console.error(err);
//       alert(err.response?.data?.message || 'Failed to add MCQ');
//     } finally {
//       setAddingMcq(false);
//     }
//   };

//   // Helper function to group MCQs by Subject -> SubSubject -> Topic -> Chapter
//   // Subject → SubSubject → Chapter → Topic
//   const groupByHierarchy = (mcqList) => {
//     return mcqList.reduce((acc, mcq) => {
//       const subject = mcq.subjectId?.name || 'Uncategorized';
//       const subSubject = mcq.subSubjectId?.name || 'General';
//       const chapter = mcq.chapterId?.name || 'No Chapter';
//       const topic = mcq.topicId?.name || 'Miscellaneous';

//       if (!acc[subject]) acc[subject] = {};
//       if (!acc[subject][subSubject]) acc[subject][subSubject] = {};
//       if (!acc[subject][subSubject][chapter])
//         acc[subject][subSubject][chapter] = {};
//       if (!acc[subject][subSubject][chapter][topic])
//         acc[subject][subSubject][chapter][topic] = [];

//       acc[subject][subSubject][chapter][topic].push(mcq);
//       return acc;
//     }, {});
//   };
//   let serialNo = 1;
//   return (
//     <Box
//       minH="100vh"
//       bg={useColorModeValue('gray.50', 'gray.900')}
//       pt={{ base: '90px', md: '100px' }}
//       pb="12"
//       px={{ base: '4', md: '6', lg: '8' }}
//     >
//       <Button
//         size="md"
//         variant="ghost"
//         colorScheme="gray"
//         mb={6}
//         leftIcon={<MdArrowBack />}
//         _hover={{ bg: useColorModeValue('gray.100', 'gray.700') }}
//         onClick={() => {
//           if (mode === 'regular') {
//             navigate('/admin/q-test-list', { state: { refresh: true } });
//           } else if (mode === 'exam') {
//             navigate('/admin/test-list', { state: { refresh: true } });
//           } else {
//             navigate('/admin/dashboard'); // ya manual route
//           }
//         }}
//       >
//         Back to Tests
//       </Button>

//       <Card
//         bg={bgCard}
//         shadow="2xl"
//         borderRadius="2xl"
//         overflow="hidden"
//         border="1px solid"
//         borderColor={borderColor}
//         maxW="1400px"
//         mx="auto"
//       >
//         <CardHeader bg={headerBg} py={8} px={{ base: 6, md: 10 }}>
//           <VStack align="stretch" spacing={5}>
//             <HStack justify="space-between" align="start" spacing={4}>
//               <HStack spacing={4} flex={1}>
//                 <Icon as={MdOutlineQuiz} boxSize={8} color={accentColor} />
//                 <VStack align="start" spacing={1}>
//                   <Heading size="lg" color={accentColor} lineHeight="tight">
//                     {mode === 'manual'
//                       ? 'Manual MCQ Repository'
//                       : mode === 'regular'
//                         ? 'Q-Test MCQ Repository'
//                         : 'Exam Test MCQ Repository'}
//                   </Heading>
//                   <Text fontSize="sm" color={secondaryText}>
//                     Manage and review multiple choice questions
//                   </Text>
//                 </VStack>
//               </HStack>
//               <Badge
//                 fontSize="lg"
//                 colorScheme="purple"
//                 px={5}
//                 py={2}
//                 borderRadius="lg"
//                 whiteSpace="nowrap"
//               >
//                 {totalMcqCount} Questions
//               </Badge>
//             </HStack>
//             {isQTestListPage && !testIdFromList && (
//               <Box
//                 p={4}
//                 bg={addMcqContainerBg}
//                 borderRadius="lg"
//                 border="1px solid"
//                 borderColor={borderColor}
//               >
//                 <VStack align="stretch" spacing={2}>
//                   <HStack spacing={3} align="flex-start">
//                     <Box flex="1">
//                       <Select
//                         placeholder={
//                           chaptersLoading
//                             ? 'Loading chapters...'
//                             : 'All Chapters'
//                         }
//                         value={selectedChapterId}
//                         onChange={(e) => {
//                           setPage(1);
//                           setSelectedChapterId(e.target.value);
//                         }}
//                         bg={addMcqInputBg}
//                         size="sm"
//                         isDisabled={chaptersLoading}
//                       >
//                         {chapters.map((chapter) => (
//                           <option key={chapter._id} value={chapter._id}>
//                             {chapter.name}
//                           </option>
//                         ))}
//                       </Select>
//                     </Box>

//                     {chaptersError && (
//                       <Button
//                         size="sm"
//                         variant="outline"
//                         colorScheme="blue"
//                         onClick={fetchChapters}
//                       >
//                         Retry
//                       </Button>
//                     )}
//                   </HStack>

//                   {chaptersError && (
//                     <Text fontSize="xs" color="red.400">
//                       {chaptersError}
//                     </Text>
//                   )}
//                 </VStack>
//               </Box>
//             )}
//             {isQTestListPage && testIdFromList && (
//               <Box
//                 p={3}
//                 bg="blue.50"
//                 border="1px solid"
//                 borderColor="blue.200"
//                 borderRadius="md"
//               >
//                 <Text fontSize="sm" color="blue.700">
//                   You are viewing MCQs for a specific test. Chapter filtering is
//                   not available in this view. To use chapter filters, please
//                   open the MCQ list directly from the main route.
//                 </Text>
//               </Box>
//             )}
//             {testIdFromList && (
//               <Box
//                 p={4}
//                 bg={addMcqContainerBg}
//                 borderRadius="lg"
//                 border="1px solid"
//                 borderColor={borderColor}
//               >
//                 <HStack spacing={3}>
//                   <Input
//                     placeholder="Enter MCQ Codon ID to add..."
//                     value={mcqIdInput}
//                     onChange={(e) => setMcqIdInput(e.target.value)}
//                     bg={addMcqInputBg}
//                     size="sm"
//                     borderRadius="md"
//                   />
//                   <Button
//                     colorScheme="green"
//                     isLoading={addingMcq}
//                     onClick={handleAddMcqToTest}
//                     size="sm"
//                     minW="fit-content"
//                   >
//                     Add MCQ
//                   </Button>
//                 </HStack>
//               </Box>
//             )}
//           </VStack>
//         </CardHeader>

//         <CardBody p={{ base: 5, md: 8 }}>
//           {loading ? (
//             <Flex justify="center" align="center" minH="60vh">
//               <VStack spacing={4}>
//                 <Spinner
//                   thickness="4px"
//                   speed="0.65s"
//                   emptyColor="gray.200"
//                   color={accentColor}
//                   size="xl"
//                 />
//                 <Text color={secondaryText}>Loading questions...</Text>
//               </VStack>
//             </Flex>
//           ) : error ? (
//             <Flex
//               justify="center"
//               align="center"
//               minH="50vh"
//               direction="column"
//               gap={4}
//             >
//               <Text fontSize="lg" color="red.400">
//                 {error}
//               </Text>
//               <Button
//                 colorScheme="blue"
//                 variant="outline"
//                 onClick={fetchMcqsTestWise}
//               >
//                 Retry
//               </Button>
//             </Flex>
//           ) : testsWithMcqs.length === 0 ? (
//             <Flex
//               justify="center"
//               align="center"
//               minH="50vh"
//               direction="column"
//               gap={4}
//             >
//               <Icon as={MdOutlineQuiz} boxSize={16} color="gray.400" />
//               <Text fontSize="xl" color={secondaryText}>
//                 {hasActiveChapterFilter
//                   ? 'No MCQs match the selected chapter'
//                   : testIdFromList
//                     ? 'No MCQs found for this test'
//                     : 'No tests with MCQs found'}
//               </Text>
//               <Button
//                 size="sm"
//                 variant="outline"
//                 colorScheme="blue"
//                 onClick={() =>
//                   navigate(
//                     mode === 'regular'
//                       ? '/admin/q-test-list'
//                       : '/admin/test-list',
//                   )
//                 }
//               >
//                 Back to Tests
//               </Button>
//             </Flex>
//           ) : (
//             testsWithMcqs.map((testGroup) => {
//               const testKey = testGroup.testId ?? 'manual';
//               const mcqsInTest = testGroup.mcqList || [];
//               return (
//                 <Box key={testKey} mb={10}>
//                   {/* Test section header */}
//                   <Box
//                     p={5}
//                     bg={headerBg}
//                     borderRadius="xl"
//                     border="2px solid"
//                     borderColor={accentColor}
//                     mb={6}
//                     cursor="pointer"
//                     onClick={() =>
//                       setExpandedTestId(
//                         expandedTestId === testKey ? null : testKey,
//                       )
//                     }
//                     _hover={{ boxShadow: 'lg', transform: 'translateY(-2px)' }}
//                     transition="all 0.3s ease"
//                   >
//                     <HStack justify="space-between" align="center">
//                       <HStack spacing={4}>
//                         <Icon
//                           as={MdOutlineQuiz}
//                           boxSize={8}
//                           color={accentColor}
//                         />
//                         <VStack align="start" spacing={1}>
//                           <HStack spacing={3}>
//                             <Heading size="md" color={accentColor}>
//                               {testGroup.testName ||
//                                 testGroup.test?.name ||
//                                 'Manual MCQs'}
//                             </Heading>

//                             {(testGroup.testId === null ||
//                               testKey === 'manual') && (
//                               <Badge
//                                 colorScheme="purple"
//                                 variant="solid"
//                                 fontSize="xs"
//                               >
//                                 Manual
//                               </Badge>
//                             )}
//                           </HStack>

//                           <Text fontSize="xs" color={secondaryText}>
//                             {expandedTestId === testKey
//                               ? '▼ Click to collapse'
//                               : '▶ Click to expand'}
//                           </Text>
//                         </VStack>
//                       </HStack>
//                       <Badge
//                         fontSize="lg"
//                         colorScheme="purple"
//                         px={4}
//                         py={2}
//                         borderRadius="lg"
//                       >
//                         {mcqsInTest.length} MCQs
//                       </Badge>
//                     </HStack>
//                   </Box>

//                   {expandedTestId === testKey && (
//                     <VStack spacing={8} align="stretch" pl={{ base: 0, md: 4 }}>
//                       {mcqsInTest.length === 0 ? (
//                         <Box
//                           p={8}
//                           textAlign="center"
//                           border="1px dashed"
//                           borderColor={borderColor}
//                           borderRadius="lg"
//                         >
//                           <Text color={secondaryText} fontSize="lg">
//                             {hasActiveChapterFilter
//                               ? 'No MCQs in this test match the selected chapter'
//                               : 'No MCQs found for this test'}
//                           </Text>
//                         </Box>
//                       ) : (
//                         Object.entries(groupByHierarchy(mcqsInTest))
//                           .filter(([_, subSubjects]) =>
//                             Object.values(subSubjects).some((chapters) =>
//                               Object.values(chapters).some((topics) =>
//                                 Object.values(topics).some(
//                                   (items) => items.length > 0,
//                                 ),
//                               ),
//                             ),
//                           )
//                           .map(([subject, subSubjects]) => (
//                             <Box key={subject}>
//                               <HStack mb={4}>
//                                 <Icon
//                                   as={MdSchool}
//                                   boxSize={6}
//                                   color={accentColor}
//                                 />
//                                 <Heading size="md" color={accentColor}>
//                                   {subject}
//                                 </Heading>
//                               </HStack>
//                               <Box
//                                 border="1px solid"
//                                 borderColor={borderColor}
//                                 borderRadius="xl"
//                                 overflow="hidden"
//                                 boxShadow="sm"
//                               >
//                                 <Table variant="simple" size="md">
//                                   <Thead bg={tableBg}>
//                                     <Tr>
//                                       <Th>S/No.</Th>
//                                       <Th>Sub Subjects</Th>
//                                       <Th>Chapter</Th>
//                                       <Th>Topic</Th>
//                                       <Th>Tags</Th>
//                                       <Th>Total Questions</Th>
//                                       <Th>Action</Th>
//                                     </Tr>
//                                   </Thead>
//                                   <Tbody>
//                                     {Object.entries(subSubjects).flatMap(
//                                       ([subSubject, chapters]) =>
//                                         Object.entries(chapters).flatMap(
//                                           ([chapter, topics]) =>
//                                             Object.entries(topics)
//                                               .filter(
//                                                 ([topic, items]) =>
//                                                   items.length > 0,
//                                               )
//                                               .map(([topic, items]) => {
//                                                 console.log(
//                                                   'MCQ items:',
//                                                   items,
//                                                 ); // ✅ DEBUG LINE
//                                                 const chapterKey = `${subject}-${subSubject}-${chapter}-${topic}`;
//                                                 const tags = Array.from(
//                                                   new Set(
//                                                     items.flatMap(
//                                                       (m) => m.tags || [],
//                                                     ),
//                                                   ),
//                                                 );

//                                                 return (
//                                                   <React.Fragment
//                                                     key={chapterKey}
//                                                   >
//                                                     <Tr
//                                                       _hover={{ bg: bgHover }}
//                                                     >
//                                                       <Td fontWeight="medium">
//                                                         {serialNo++}
//                                                       </Td>
//                                                       <Td fontWeight="medium">
//                                                         {subSubject}
//                                                       </Td>

//                                                       {/* ✅ Chapter first */}
//                                                       <Td>{chapter}</Td>

//                                                       {/* ✅ Topic after Chapter */}
//                                                       <Td>{topic}</Td>

//                                                       <Td>
//                                                         <Wrap>
//                                                           {tags.length > 0 ? (
//                                                             tags.map(
//                                                               (tag, i) => (
//                                                                 <WrapItem
//                                                                   key={i}
//                                                                 >
//                                                                   <Badge
//                                                                     colorScheme="teal"
//                                                                     variant="subtle"
//                                                                     px={2}
//                                                                   >
//                                                                     {tag}
//                                                                   </Badge>
//                                                                 </WrapItem>
//                                                               ),
//                                                             )
//                                                           ) : (
//                                                             <Text
//                                                               fontSize="sm"
//                                                               color={
//                                                                 secondaryText
//                                                               }
//                                                             >
//                                                               —
//                                                             </Text>
//                                                           )}
//                                                         </Wrap>
//                                                       </Td>

//                                                       <Td>
//                                                         <Badge
//                                                           colorScheme="purple"
//                                                           borderRadius="full"
//                                                           px={3}
//                                                         >
//                                                           {items.length}
//                                                         </Badge>
//                                                       </Td>

//                                                       <Td>
//                                                         <Button
//                                                           size="sm"
//                                                           colorScheme="blue"
//                                                           variant="solid"
//                                                           borderRadius="md"
//                                                           boxShadow="sm"
//                                                           _hover={{
//                                                             boxShadow: 'md',
//                                                           }}
//                                                           onClick={() =>
//                                                             setExpandedChapterKey(
//                                                               expandedChapterKey ===
//                                                                 chapterKey
//                                                                 ? null
//                                                                 : chapterKey,
//                                                             )
//                                                           }
//                                                         >
//                                                           {expandedChapterKey ===
//                                                           chapterKey
//                                                             ? 'Hide'
//                                                             : 'View Questions'}
//                                                         </Button>
//                                                       </Td>
//                                                     </Tr>

//                                                     {expandedChapterKey ===
//                                                       chapterKey && (
//                                                       <Tr>
//                                                         <Td colSpan={6} p={4}>
//                                                           <Box
//                                                             border="1px solid"
//                                                             borderColor={
//                                                               borderColor
//                                                             }
//                                                             borderRadius="xl"
//                                                             overflow="hidden"
//                                                             boxShadow="sm"
//                                                           >
//                                                             <Table
//                                                               variant="simple"
//                                                               size="sm"
//                                                             >
//                                                               <Thead
//                                                                 bg={tableBg}
//                                                               >
//                                                                 <Tr>
//                                                                   <Th>S/No.</Th>
//                                                                   <Th>
//                                                                     Question
//                                                                   </Th>
//                                                                   <Th>
//                                                                     Correct
//                                                                     Answer
//                                                                   </Th>
//                                                                   <Th>
//                                                                     Difficulty
//                                                                   </Th>
//                                                                   <Th>Tags</Th>
//                                                                   <Th>View</Th>
//                                                                   <Th>
//                                                                     Delete
//                                                                   </Th>
//                                                                   <Th>Edit</Th>
//                                                                 </Tr>
//                                                               </Thead>
//                                                               <Tbody>
//                                                                 {items.map(
//                                                                   (
//                                                                     mcq,
//                                                                     index,
//                                                                   ) => (
//                                                                     <Tr
//                                                                       key={
//                                                                         mcq._id
//                                                                       }
//                                                                       _hover={{
//                                                                         bg: bgHover,
//                                                                       }}
//                                                                     >
//                                                                       <Td>
//                                                                         {index +
//                                                                           1}
//                                                                       </Td>
//                                                                       <Td maxW="420px">
//                                                                         <Text
//                                                                           noOfLines={
//                                                                             2
//                                                                           }
//                                                                         >
//                                                                           {mcq
//                                                                             .question
//                                                                             ?.text ||
//                                                                             '—'}
//                                                                         </Text>
//                                                                       </Td>

//                                                                       <Td
//                                                                         color="green.600"
//                                                                         fontWeight="semibold"
//                                                                       >
//                                                                         {mcq
//                                                                           .options?.[
//                                                                           mcq
//                                                                             .correctAnswer
//                                                                         ]
//                                                                           ?.text ||
//                                                                           '—'}
//                                                                       </Td>

//                                                                       <Td>
//                                                                         <Badge
//                                                                           colorScheme={getDifficultyColor(
//                                                                             mcq.difficulty,
//                                                                           )}
//                                                                           px={3}
//                                                                         >
//                                                                           {
//                                                                             mcq.difficulty
//                                                                           }
//                                                                         </Badge>
//                                                                       </Td>

//                                                                       <Td>
//                                                                         <Wrap>
//                                                                           {(
//                                                                             mcq.tags ||
//                                                                             []
//                                                                           ).map(
//                                                                             (
//                                                                               tag,
//                                                                               i,
//                                                                             ) => (
//                                                                               <WrapItem
//                                                                                 key={
//                                                                                   i
//                                                                                 }
//                                                                               >
//                                                                                 <Badge
//                                                                                   colorScheme="teal"
//                                                                                   variant="subtle"
//                                                                                   px={
//                                                                                     2
//                                                                                   }
//                                                                                 >
//                                                                                   {
//                                                                                     tag
//                                                                                   }
//                                                                                 </Badge>
//                                                                               </WrapItem>
//                                                                             ),
//                                                                           )}
//                                                                         </Wrap>
//                                                                       </Td>

//                                                                       <Td>
//                                                                         <Button
//                                                                           size="sm"
//                                                                           colorScheme="blue"
//                                                                           variant="solid"
//                                                                           borderRadius="md"
//                                                                           boxShadow="sm"
//                                                                           _hover={{
//                                                                             boxShadow:
//                                                                               'md',
//                                                                           }}
//                                                                           onClick={() =>
//                                                                             openModal(
//                                                                               mcq,
//                                                                             )
//                                                                           }
//                                                                         >
//                                                                           View
//                                                                         </Button>
//                                                                       </Td>

//                                                                       <Td>
//                                                                         <Button
//                                                                           size="sm"
//                                                                           colorScheme="red"
//                                                                           variant="outline"
//                                                                           borderRadius="md"
//                                                                           _hover={{
//                                                                             bg: 'red.50',
//                                                                           }}
//                                                                           onClick={() =>
//                                                                             handleDeleteMcq(
//                                                                               mcq._id,
//                                                                             )
//                                                                           }
//                                                                         >
//                                                                           Delete
//                                                                         </Button>
//                                                                       </Td>

//                                                                       <Td>
//                                                                         <Button
//                                                                           size="sm"
//                                                                           colorScheme="orange"
//                                                                           variant="solid"
//                                                                           borderRadius="md"
//                                                                           boxShadow="sm"
//                                                                           _hover={{
//                                                                             boxShadow:
//                                                                               'md',
//                                                                           }}
//                                                                           onClick={() =>
//                                                                             navigate(
//                                                                               `/admin/mcq/${mcq.testMode || 'manual'}`,
//                                                                               {
//                                                                                 state:
//                                                                                   {
//                                                                                     editMcq:
//                                                                                       mcq,
//                                                                                     mode: 'edit',
//                                                                                   },
//                                                                               },
//                                                                             )
//                                                                           }
//                                                                         >
//                                                                           Edit
//                                                                         </Button>
//                                                                       </Td>
//                                                                     </Tr>
//                                                                   ),
//                                                                 )}
//                                                               </Tbody>
//                                                             </Table>
//                                                           </Box>
//                                                         </Td>
//                                                       </Tr>
//                                                     )}
//                                                   </React.Fragment>
//                                                 );
//                                               }),
//                                         ),
//                                     )}
//                                   </Tbody>
//                                 </Table>
//                               </Box>
//                             </Box>
//                           ))
//                       )}
//                     </VStack>
//                   )}
//                 </Box>
//               );
//             })
//           )}
//         </CardBody>

//         {/* 🔧 CHANGE 5 — Add Pagination Controls */}
//         {!loading && testsWithMcqs.length > 0 && totalPages > 1 && (
//           <Box
//             borderTop="2px solid"
//             borderColor={borderColor}
//             p={{ base: 6, md: 8 }}
//             bg={headerBg}
//           >
//             <VStack spacing={4}>
//               <HStack justify="center" spacing={4} wrap="wrap">
//                 <Button
//                   isDisabled={page === 1}
//                   colorScheme="blue"
//                   variant="solid"
//                   size="md"
//                   leftIcon={<MdChevronLeft />}
//                   onClick={() => setPage((p) => Math.max(1, p - 1))}
//                   _disabled={{ opacity: 0.5, cursor: 'not-allowed' }}
//                   boxShadow="sm"
//                 >
//                   Previous
//                 </Button>

//                 <HStack
//                   spacing={3}
//                   px={6}
//                   py={3}
//                   bg={paginationBoxBg}
//                   borderRadius="lg"
//                   border="1px solid"
//                   borderColor={borderColor}
//                   boxShadow="sm"
//                 >
//                   <VStack spacing={0}>
//                     <Text fontSize="xs" color={secondaryText}>
//                       Page
//                     </Text>
//                     <Text fontSize="xl" fontWeight="bold" color={accentColor}>
//                       {page}
//                     </Text>
//                   </VStack>
//                   <Text fontSize="lg" color={secondaryText}>
//                     /
//                   </Text>
//                   <VStack spacing={0}>
//                     <Text fontSize="xs" color={secondaryText}>
//                       of
//                     </Text>
//                     <Text fontSize="xl" fontWeight="bold" color={accentColor}>
//                       {totalPages}
//                     </Text>
//                   </VStack>
//                 </HStack>

//                 <Button
//                   isDisabled={page === totalPages}
//                   colorScheme="blue"
//                   variant="solid"
//                   size="md"
//                   rightIcon={<MdChevronRight />}
//                   onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
//                   _disabled={{ opacity: 0.5, cursor: 'not-allowed' }}
//                   boxShadow="sm"
//                 >
//                   Next
//                 </Button>
//               </HStack>
//               <Text fontSize="sm" color={secondaryText} fontStyle="italic">
//                 {(page - 1) * limit + 1} –{' '}
//                 {Math.min(page * limit, totalMcqCount)} of {totalMcqCount}{' '}
//                 questions
//               </Text>
//             </VStack>
//           </Box>
//         )}
//       </Card>

//       <Modal isOpen={isModalOpen} onClose={closeModal} size="xl" isCentered>
//         <ModalOverlay />
//         <ModalContent borderRadius="2xl" boxShadow="2xl">
//           <ModalHeader
//             bg={headerBg}
//             py={6}
//             px={8}
//             borderBottom="1px solid"
//             borderColor={borderColor}
//           >
//             <HStack spacing={3}>
//               <Icon as={MdOutlineQuiz} boxSize={6} color={accentColor} />
//               <Heading size="md" color={accentColor}>
//                 Question Details
//               </Heading>
//             </HStack>
//           </ModalHeader>
//           <ModalCloseButton mt={4} mr={4} />
//           <ModalBody pb={8} pt={6}>
//             {selectedMcq && (
//               <VStack align="stretch" spacing={6}>
//                 <Box>
//                   <Heading
//                     size="md"
//                     mb={3}
//                     color={accentColor}
//                     display="flex"
//                     alignItems="center"
//                     gap={2}
//                   >
//                     📝 Question
//                   </Heading>
//                   <Text lineHeight="1.8">{selectedMcq.question?.text}</Text>
//                   {selectedMcq.question?.images?.map((img, i) => (
//                     <Image
//                       key={i}
//                       src={getImageUrl(img)}
//                       maxH="220px"
//                       mt={4}
//                       borderRadius="lg"
//                       objectFit="contain"
//                       border="1px solid"
//                       borderColor={borderColor}
//                       p={2}
//                     />
//                   ))}
//                 </Box>

//                 <Divider />

//                 <Box>
//                   <Heading
//                     size="md"
//                     mb={4}
//                     color={accentColor}
//                     display="flex"
//                     alignItems="center"
//                     gap={2}
//                   >
//                     ✓ Options
//                   </Heading>
//                   <VStack spacing={3} align="stretch">
//                     {selectedMcq.options?.map((opt, i) => (
//                       <Box
//                         key={i}
//                         p={4}
//                         borderRadius="lg"
//                         border="2px solid"
//                         borderColor={
//                           selectedMcq.correctAnswer === i
//                             ? 'green.500'
//                             : borderColor
//                         }
//                         bg={
//                           selectedMcq.correctAnswer === i
//                             ? correctOptionBgColor
//                             : optionBoxDefaultBg
//                         }
//                         transition="all 0.2s"
//                       >
//                         <HStack align="start" gap={4}>
//                           <Box
//                             minW="32px"
//                             h="32px"
//                             display="flex"
//                             alignItems="center"
//                             justifyContent="center"
//                             bg={
//                               selectedMcq.correctAnswer === i
//                                 ? 'green.500'
//                                 : accentColor
//                             }
//                             color="white"
//                             borderRadius="md"
//                             fontWeight="bold"
//                           >
//                             {String.fromCharCode(65 + i)}
//                           </Box>
//                           <Box flex={1}>
//                             <Text lineHeight="1.6">{opt.text}</Text>
//                             {opt.image && (
//                               <Image
//                                 src={getImageUrl(opt.image)}
//                                 maxH="140px"
//                                 mt={3}
//                                 borderRadius="md"
//                                 objectFit="contain"
//                               />
//                             )}
//                           </Box>
//                           {selectedMcq.correctAnswer === i && (
//                             <Icon
//                               as={MdCheckCircle}
//                               boxSize={6}
//                               color="green.500"
//                               flexShrink={0}
//                             />
//                           )}
//                         </HStack>
//                       </Box>
//                     ))}
//                   </VStack>
//                 </Box>

//                 {(selectedMcq.explanation?.text ||
//                   selectedMcq.explanation?.images?.length > 0) && (
//                   <Box>
//                     <Divider my={2} />
//                     <Heading
//                       size="md"
//                       mt={6}
//                       mb={4}
//                       color={accentColor}
//                       display="flex"
//                       alignItems="center"
//                       gap={2}
//                     >
//                       💡 Explanation
//                     </Heading>
//                     {selectedMcq.explanation?.text && (
//                       <Box
//                         p={4}
//                         bg={explanationBoxBg}
//                         borderRadius="lg"
//                         border="1px solid"
//                         borderColor={explanationBorderColor}
//                         lineHeight="1.8"
//                         dangerouslySetInnerHTML={{
//                           __html: DOMPurify.sanitize(
//                             selectedMcq.explanation.text,
//                           ),
//                         }}
//                       />
//                     )}
//                     {selectedMcq.explanation?.images?.map((img, i) => (
//                       <Image
//                         key={i}
//                         src={getImageUrl(img)}
//                         maxH="240px"
//                         mt={4}
//                         borderRadius="lg"
//                         objectFit="contain"
//                       />
//                     ))}
//                   </Box>
//                 )}
//               </VStack>
//             )}
//           </ModalBody>
//         </ModalContent>
//       </Modal>
//     </Box>
//   );
// }

'use client';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import {
  Box,
  Flex,
  Text,
  Heading,
  useColorModeValue,
  Badge,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Image,
  VStack,
  HStack,
  Icon,
  Spinner,
  Divider,
  Card,
  CardBody,
  CardHeader,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Button,
  Wrap,
  WrapItem,
  Input,
  Select,
  SimpleGrid,
  InputGroup,
  InputLeftElement,
  Tooltip,
} from '@chakra-ui/react';
import {
  MdCheckCircle,
  MdSchool,
  MdOutlineQuiz,
  MdChevronLeft,
  MdChevronRight,
  MdArrowBack,
  MdSearch,
  MdFilterList,
  MdMenuBook,
  MdTopic,
  MdClass,
} from 'react-icons/md';
import axios from 'axios';
import DOMPurify from 'dompurify';
import { useLocation, useNavigate } from 'react-router-dom';

const normaliseQtestMcqs = (payload) => {
  const raw = payload?.data ?? payload ?? [];

  if (Array.isArray(raw)) {
    const flattened = raw.flatMap((item) =>
      Array.isArray(item?.mcqList) ? item.mcqList : item,
    );

    return flattened.filter((item) => item && item._id);
  }

  return [];
};

// ─────────────────────────────────────────────────────────────────────────────
// SUB-COMPONENTS: Hierarchy Browser (Subject → Sub-Subject → Chapter/Topic)
// ─────────────────────────────────────────────────────────────────────────────

/** Pill/chip selector used for Subject and Sub-Subject lists */
function HierarchyChip({ label, isSelected, onClick, colorScheme = 'purple' }) {
  const selectedBg = useColorModeValue(
    `${colorScheme}.50`,
    `${colorScheme}.900`,
  );
  const selectedColor = useColorModeValue(
    `${colorScheme}.700`,
    `${colorScheme}.200`,
  );
  const selectedBorder = useColorModeValue(
    `${colorScheme}.400`,
    `${colorScheme}.500`,
  );
  const defaultBg = useColorModeValue('white', 'gray.700');
  const defaultColor = useColorModeValue('gray.700', 'gray.200');
  const defaultBorder = useColorModeValue('gray.200', 'gray.500');
  const hoverBg = useColorModeValue(`${colorScheme}.50`, `${colorScheme}.900`);

  return (
    <Button
      size="sm"
      variant="outline"
      onClick={onClick}
      bg={isSelected ? selectedBg : defaultBg}
      color={isSelected ? selectedColor : defaultColor}
      borderColor={isSelected ? selectedBorder : defaultBorder}
      borderWidth={isSelected ? '2px' : '1px'}
      fontWeight={isSelected ? '600' : '400'}
      _hover={{ bg: hoverBg, borderColor: selectedBorder }}
      transition="all 0.15s"
      borderRadius="full"
      px={4}
    >
      {label}
    </Button>
  );
}

/** Breadcrumb strip shown above the hierarchy table */
function HierarchyBreadcrumb({ subject, subSubject, chapter, topic }) {
  const accentColor = useColorModeValue('purple.600', 'purple.300');
  const mutedColor = useColorModeValue('gray.500', 'gray.400');
  const sepColor = useColorModeValue('gray.300', 'gray.600');

  const parts = [
    subject && { label: subject, icon: MdSchool },
    subSubject && { label: subSubject, icon: MdMenuBook },
    chapter && { label: chapter, icon: MdClass },
    topic && { label: topic, icon: MdTopic },
  ].filter(Boolean);

  if (parts.length === 0) return null;

  return (
    <HStack spacing={1} flexWrap="wrap" mb={4}>
      {parts.map((p, i) => (
        <React.Fragment key={i}>
          {i > 0 && (
            <Text fontSize="xs" color={sepColor} mx={1}>
              ›
            </Text>
          )}
          <HStack spacing={1}>
            <Icon
              as={p.icon}
              boxSize={3}
              color={i === parts.length - 1 ? accentColor : mutedColor}
            />
            <Text
              fontSize="sm"
              fontWeight={i === parts.length - 1 ? '600' : '400'}
              color={i === parts.length - 1 ? accentColor : mutedColor}
            >
              {p.label}
            </Text>
          </HStack>
        </React.Fragment>
      ))}
    </HStack>
  );
}

const getEntityId = (value) => {
  if (!value) return '';
  if (typeof value === 'object') {
    return String(value._id || value.id || '');
  }
  return String(value);
};

const getEntityName = (value) => {
  if (!value || typeof value !== 'object') return '';
  return value.name || value.title || '';
};

const buildTestBranchesFromMcqs = (mcqs = []) => {
  const branchMap = new Map();

  mcqs.forEach((mcq) => {
    const subjectId = getEntityId(mcq.subjectId);
    const subSubjectId = getEntityId(mcq.subSubjectId);

    if (!subjectId || !subSubjectId) return;

    const branchKey = `${subjectId}::${subSubjectId}`;

    if (!branchMap.has(branchKey)) {
      branchMap.set(branchKey, {
        subjectId,
        subjectName: getEntityName(mcq.subjectId),
        subSubjectId,
        subSubjectName: getEntityName(mcq.subSubjectId),
        mcqCount: 0,
        chapterMap: new Map(),
        topicMap: new Map(),
      });
    }

    const branch = branchMap.get(branchKey);
    branch.mcqCount += 1;

    const chapterId = getEntityId(mcq.chapterId);
    const chapterName = getEntityName(mcq.chapterId);
    const topicId = getEntityId(mcq.topicId);
    const topicName = getEntityName(mcq.topicId);

    if (chapterId) {
      if (!branch.chapterMap.has(chapterId)) {
        branch.chapterMap.set(chapterId, {
          id: chapterId,
          name: chapterName,
          count: 0,
        });
      }

      branch.chapterMap.get(chapterId).count += 1;
    }

    if (topicId) {
      if (!branch.topicMap.has(topicId)) {
        branch.topicMap.set(topicId, {
          id: topicId,
          name: topicName,
          count: 0,
        });
      }

      branch.topicMap.get(topicId).count += 1;
    }
  });

  return Array.from(branchMap.values())
    .map((branch) => {
      const chapters = Array.from(branch.chapterMap.values()).sort((a, b) => {
        if (b.count !== a.count) return b.count - a.count;
        return String(a.name || '').localeCompare(String(b.name || ''));
      });

      const topics = Array.from(branch.topicMap.values()).sort((a, b) => {
        if (b.count !== a.count) return b.count - a.count;
        return String(a.name || '').localeCompare(String(b.name || ''));
      });

      return {
        subjectId: branch.subjectId,
        subjectName: branch.subjectName,
        subSubjectId: branch.subSubjectId,
        subSubjectName: branch.subSubjectName,
        mcqCount: branch.mcqCount,
        chapterCount: chapters.length,
        topicCount: topics.length,
        chapters,
        topics,
        chapterIds: chapters.map((chapter) => chapter.id),
        chapterNames: chapters.map((chapter) => chapter.name).filter(Boolean),
        topicNames: topics.map((topic) => topic.name).filter(Boolean),
        primaryChapterId: chapters[0]?.id || '',
        primaryChapterName: chapters[0]?.name || '',
        primaryTopicId: topics[0]?.id || '',
        primaryTopicName: topics[0]?.name || '',
      };
    })
    .sort((a, b) => {
      if (b.mcqCount !== a.mcqCount) return b.mcqCount - a.mcqCount;
      return String(a.subSubjectName || '').localeCompare(
        String(b.subSubjectName || ''),
      );
    });
};

const buildFallbackBranchFromTest = (test) => {
  const subjectId = getEntityId(test?.subjectId);
  const subSubjectId = getEntityId(test?.subSubjectId);
  const chapterId = getEntityId(test?.chapterId);

  if (!subjectId || !subSubjectId) {
    return [];
  }

  const chapterName = getEntityName(test?.chapterId);

  return [
    {
      subjectId,
      subjectName: getEntityName(test?.subjectId),
      subSubjectId,
      subSubjectName: getEntityName(test?.subSubjectId),
      mcqCount: Number(test?.totalQuestions || 0),
      chapterCount: chapterId ? 1 : 0,
      topicCount: 0,
      chapters: chapterId
        ? [
            {
              id: chapterId,
              name: chapterName,
              count: Number(test?.totalQuestions || 0),
            },
          ]
        : [],
      topics: [],
      chapterIds: chapterId ? [chapterId] : [],
      chapterNames: chapterName ? [chapterName] : [],
      topicNames: [],
      primaryChapterId: chapterId,
      primaryChapterName: chapterName,
      primaryTopicId: '',
      primaryTopicName: '',
    },
  ];
};

const getDefaultTestBranch = (test, branches = []) => {
  if (!Array.isArray(branches) || branches.length === 0) return null;

  if (test?.testMode === 'regular') {
    const targetSubjectId = getEntityId(test.subjectId);
    const targetSubSubjectId = getEntityId(test.subSubjectId);
    const targetChapterId = getEntityId(test.chapterId);

    const matchedBranch =
      branches.find(
        (branch) =>
          branch.subjectId === targetSubjectId &&
          branch.subSubjectId === targetSubSubjectId,
      ) || branches[0];

    return {
      ...matchedBranch,
      primaryChapterId: targetChapterId || matchedBranch.primaryChapterId || '',
      primaryChapterName:
        getEntityName(test.chapterId) ||
        matchedBranch.primaryChapterName ||
        matchedBranch.chapterNames?.[0] ||
        '',
    };
  }

  return branches[0];
};

// ─────────────────────────────────────────────────────────────────────────────
// MAIN COMPONENT
// ─────────────────────────────────────────────────────────────────────────────

export default function MCQList({ mode = 'all' }) {
  // ── Color tokens (ALL original tokens preserved) ──────────────────────────
  const bgCard = useColorModeValue('white', 'gray.800');
  const bgHover = useColorModeValue('gray.50', 'gray.700');
  const borderColor = useColorModeValue('gray.200', 'gray.600');
  const secondaryText = useColorModeValue('gray.600', 'gray.400');
  const accentColor = useColorModeValue('purple.600', 'purple.300');
  const headerBg = useColorModeValue('purple.50', 'gray.800');
  const correctOptionBgColor = useColorModeValue('green.50', 'green.900');
  const tableBg = useColorModeValue('gray.100', 'gray.700');
  const addMcqContainerBg = useColorModeValue('white', 'gray.700');
  const addMcqInputBg = useColorModeValue('white', 'gray.600');
  const paginationBoxBg = useColorModeValue('white', 'gray.700');
  const optionBoxDefaultBg = useColorModeValue('gray.50', 'gray.700');
  const explanationBoxBg = useColorModeValue('yellow.50', 'yellow.900');
  const explanationBorderColor = useColorModeValue('yellow.200', 'yellow.700');

  // ── NEW: hierarchy panel colors ───────────────────────────────────────────
  const hierarchyPanelBg = useColorModeValue('white', 'gray.800');
  const hierarchyPanelBorder = useColorModeValue('gray.200', 'gray.600');
  const hierarchySectionBg = useColorModeValue('gray.50', 'gray.750');
  const subjectAccent = useColorModeValue('purple.600', 'purple.300');
  const subSubjectAccent = useColorModeValue('blue.600', 'blue.300');

  // ── Env / auth ─────────────────────────────────────────────────────────────
  const rawBaseUrl = process.env.REACT_APP_BASE_URL || 'http://localhost:4000';
  const baseUrl = rawBaseUrl.endsWith('/')
    ? rawBaseUrl.slice(0, -1)
    : rawBaseUrl;
  const token = localStorage.getItem('token') || '';
  const axiosConfig = useMemo(
    () => ({ headers: { Authorization: `Bearer ${token}` } }),
    [token],
  );

  // ── Original state (ALL preserved) ────────────────────────────────────────
  const [testsWithMcqs, setTestsWithMcqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedTestId, setExpandedTestId] = useState(null);
  const [expandedChapterKey, setExpandedChapterKey] = useState(null);
  const [selectedMcq, setSelectedMcq] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [error, setError] = useState('');
  const [mcqIdInput, setMcqIdInput] = useState('');
  const [addingMcq, setAddingMcq] = useState(false);
  const [page, setPage] = useState(1);
  const [chapters, setChapters] = useState([]);
  const [chaptersLoading, setChaptersLoading] = useState(false);
  const [chaptersError, setChaptersError] = useState('');
  const [selectedChapterId, setSelectedChapterId] = useState('');
  const [topics, setTopics] = useState([]);
  const [selectedTopicId, setSelectedTopicId] = useState('');
  const [topicsLoading, setTopicsLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(1);
  const [totalMcqCount, setTotalMcqCount] = useState(0);
  const [manualAddTopicId, setManualAddTopicId] = useState('');
  const [selectedTestContext, setSelectedTestContext] = useState(null);
  const [selectedTestContextLoading, setSelectedTestContextLoading] =
    useState(false);
  const [selectedTestContextError, setSelectedTestContextError] = useState('');
  const [pendingBranchSelection, setPendingBranchSelection] = useState(null);
  const [hasAppliedBranchSelection, setHasAppliedBranchSelection] =
    useState(false);
  const limit = 20;

  // ── NEW: EduAdmin Hierarchy Browser state ─────────────────────────────────
  const [subjects, setSubjects] = useState([]);
  const [subSubjects, setSubSubjects] = useState([]);
  const [hierarchyChapters, setHierarchyChapters] = useState([]);
  const [hierarchyTopics, setHierarchyTopics] = useState([]);

  const [selectedSubjectId, setSelectedSubjectId] = useState('');
  const [selectedSubSubjectId, setSelectedSubSubjectId] = useState('');
  const [hierarchySelectedChapterId, setHierarchySelectedChapterId] =
    useState('');
  const [hierarchyChapterFilter, setHierarchyChapterFilter] = useState(''); // dropdown filter
  const [hierarchySearch, setHierarchySearch] = useState('');

  const [subjectsLoading, setSubjectsLoading] = useState(false);
  const [subSubjectsLoading, setSubSubjectsLoading] = useState(false);
  const [hierarchyChaptersLoading, setHierarchyChaptersLoading] =
    useState(false);
  const [hierarchyTotalMcqs, setHierarchyTotalMcqs] = useState(0);

  // Track which "view" we're in: 'browser' = hierarchy page, 'mcq' = MCQ detail page
  const [hierarchyView, setHierarchyView] = useState('browser');

  // Selected topic row context (for MCQ page breadcrumb)
  const [hierarchySelectedTopicId, setHierarchySelectedTopicId] = useState('');
  const [selectedTopicName, setSelectedTopicName] = useState('');
  const [selectedChapterName, setSelectedChapterName] = useState('');
  const [selectedSubSubjectName, setSelectedSubSubjectName] = useState('');
  const [selectedSubjectName, setSelectedSubjectName] = useState('');

  // ── Router ─────────────────────────────────────────────────────────────────
  const location = useLocation();
  const navigate = useNavigate();
  const isQTestListPage = location.pathname === '/admin/mcqs-q-test-list';
  const isExamListPage = location.pathname === '/admin/mcqs-test-list';
  const testIdFromList = useMemo(
    () =>
      new URLSearchParams(location.search).get('testId') ||
      location.state?.testId ||
      null,
    [location.search, location.state],
  );
  const hasActiveChapterFilter = isQTestListPage && Boolean(selectedChapterId);
  const repositoryTitle =
    mode === 'manual'
      ? 'Manual MCQ Repository'
      : mode === 'regular'
        ? 'Q-Bank MCQ Repository'
        : 'Test Series MCQ Repository';
  const repositorySubtitle =
    mode === 'regular'
      ? 'Regular mode MCQs only'
      : mode === 'exam'
        ? 'Exam mode MCQs only'
        : 'Manage and review multiple choice questions';
  const hierarchyTitle = isQTestListPage
    ? 'Q-Bank MCQ'
    : isExamListPage
      ? 'Test Series MCQ'
      : 'MCQ Hierarchy Browser';
  const hierarchySubtitle = isQTestListPage
    ? 'Subject > Sub-Subject > Chapter > Topic > Regular MCQ'
    : isExamListPage
      ? 'Subject > Sub-Subject > Chapter > Topic > Exam MCQ'
      : 'Subject > Sub-Subject > Chapter > Topic > MCQ';
  const hierarchyBackLabel = isQTestListPage
    ? 'Back to Q-Bank MCQ'
    : isExamListPage
      ? 'Back to Test Series MCQ'
      : 'Back to MCQ Browser';

  const appendContextFilters = useCallback(
    (params) => {
      if (mode === 'manual') {
        params.set('testId', 'null');
      } else if (testIdFromList) {
        params.set('testId', testIdFromList);
      } else if (mode === 'exam' || mode === 'regular') {
        params.set('testMode', mode);
      }

      return params;
    },
    [mode, testIdFromList],
  );

  const fetchSelectedTestContext = useCallback(async () => {
    if (!testIdFromList) {
      setSelectedTestContext(null);
      setSelectedTestContextLoading(false);
      setSelectedTestContextError('');
      return;
    }

    setSelectedTestContextLoading(true);
    setSelectedTestContextError('');

    try {
      const testRes = await axios.get(
        `${baseUrl}/api/admin/tests/${testIdFromList}`,
        axiosConfig,
      );
      const test = testRes.data?.data || null;

      if (!test) {
        throw new Error('Selected test was not found');
      }

      const totalQuestions = Number(
        test.totalQuestions || test.mcqs?.length || 0,
      );
      let mcqList = [];

      if (totalQuestions > 0) {
        const params = new URLSearchParams({
          testId: testIdFromList,
          page: '1',
          limit: String(totalQuestions),
        });

        const mcqRes = await axios.get(
          `${baseUrl}/api/admin/mcqs?${params.toString()}`,
          axiosConfig,
        );

        mcqList = normaliseQtestMcqs(mcqRes.data);
      }

      const derivedBranches = buildTestBranchesFromMcqs(mcqList);
      const branches =
        derivedBranches.length > 0
          ? derivedBranches
          : buildFallbackBranchFromTest(test);
      const defaultBranch = getDefaultTestBranch(test, branches);

      setSelectedTestContext({
        ...test,
        id: test._id || testIdFromList,
        title: test.testTitle || 'Selected Test',
        totalQuestions,
        courseName: getEntityName(test.courseId),
        mcqList,
        branches,
        defaultBranch,
      });
      setPendingBranchSelection(
        defaultBranch
          ? {
              subjectId: defaultBranch.subjectId || '',
              subSubjectId: defaultBranch.subSubjectId || '',
              chapterId:
                test.testMode === 'regular'
                  ? defaultBranch.primaryChapterId || ''
                  : '',
            }
          : null,
      );
      setHasAppliedBranchSelection(false);
    } catch (err) {
      console.error('Failed to fetch selected test context:', err);
      setSelectedTestContext(null);
      setPendingBranchSelection(null);
      setSelectedTestContextError(
        err?.response?.data?.message ||
          err.message ||
          'Failed to load selected test context.',
      );
    } finally {
      setSelectedTestContextLoading(false);
    }
  }, [axiosConfig, baseUrl, testIdFromList]);

  useEffect(() => {
    fetchSelectedTestContext();
  }, [fetchSelectedTestContext]);

  const resolvedTestBranches = useMemo(
    () =>
      (selectedTestContext?.branches || []).map((branch) => {
        const matchedSubject = subjects.find(
          (subject) => String(subject._id) === String(branch.subjectId),
        );
        const matchedSubSubject = subSubjects.find(
          (item) => String(item._id) === String(branch.subSubjectId),
        );
        const matchedChapter = hierarchyChapters.find(
          (chapter) => String(chapter._id) === String(branch.primaryChapterId),
        );

        return {
          ...branch,
          subjectName:
            branch.subjectName || matchedSubject?.name || 'Selected Subject',
          subSubjectName:
            branch.subSubjectName ||
            matchedSubSubject?.name ||
            'Selected Sub-Subject',
          primaryChapterName:
            branch.primaryChapterName ||
            matchedChapter?.name ||
            branch.chapterNames?.[0] ||
            '',
        };
      }),
    [hierarchyChapters, selectedTestContext, subjects, subSubjects],
  );

  const visibleSubjects = useMemo(() => {
    if (!testIdFromList) return subjects;
    if (resolvedTestBranches.length === 0) return [];

    const scopedSubjects = new Map();

    resolvedTestBranches.forEach((branch) => {
      if (!branch.subjectId || scopedSubjects.has(branch.subjectId)) return;

      const matchedSubject = subjects.find(
        (subject) => String(subject._id) === String(branch.subjectId),
      );

      scopedSubjects.set(
        branch.subjectId,
        matchedSubject || {
          _id: branch.subjectId,
          name: branch.subjectName || 'Selected Subject',
        },
      );
    });

    return Array.from(scopedSubjects.values());
  }, [resolvedTestBranches, subjects, testIdFromList]);

  const visibleSubSubjectOptions = useMemo(() => {
    if (!selectedSubjectId) return [];

    if (!testIdFromList) {
      return subSubjects.filter(
        (item) => getEntityId(item.subjectId) === String(selectedSubjectId),
      );
    }

    const scopedSubSubjects = new Map();

    resolvedTestBranches
      .filter(
        (branch) => String(branch.subjectId) === String(selectedSubjectId),
      )
      .forEach((branch) => {
        if (
          !branch.subSubjectId ||
          scopedSubSubjects.has(branch.subSubjectId)
        ) {
          return;
        }

        const matchedSubSubject = subSubjects.find(
          (item) => String(item._id) === String(branch.subSubjectId),
        );

        scopedSubSubjects.set(
          branch.subSubjectId,
          matchedSubSubject || {
            _id: branch.subSubjectId,
            subjectId: branch.subjectId,
            name: branch.subSubjectName || 'Selected Sub-Subject',
          },
        );
      });

    return Array.from(scopedSubSubjects.values());
  }, [resolvedTestBranches, selectedSubjectId, subSubjects, testIdFromList]);

  const activeTestBranchKey = useMemo(() => {
    if (!selectedSubjectId || !selectedSubSubjectId) return '';
    return `${selectedSubjectId}::${selectedSubSubjectId}`;
  }, [selectedSubjectId, selectedSubSubjectId]);

  const currentSubjectName = useMemo(() => {
    const matchedVisibleSubject = visibleSubjects.find(
      (subject) => String(subject._id) === String(selectedSubjectId),
    );

    if (matchedVisibleSubject?.name) {
      return matchedVisibleSubject.name;
    }

    return (
      resolvedTestBranches.find(
        (branch) => String(branch.subjectId) === String(selectedSubjectId),
      )?.subjectName || ''
    );
  }, [resolvedTestBranches, selectedSubjectId, visibleSubjects]);

  const currentSubSubjectName = useMemo(() => {
    const matchedVisibleSubSubject = visibleSubSubjectOptions.find(
      (item) => String(item._id) === String(selectedSubSubjectId),
    );

    if (matchedVisibleSubSubject?.name) {
      return matchedVisibleSubSubject.name;
    }

    return (
      resolvedTestBranches.find(
        (branch) =>
          String(branch.subSubjectId) === String(selectedSubSubjectId),
      )?.subSubjectName || ''
    );
  }, [resolvedTestBranches, selectedSubSubjectId, visibleSubSubjectOptions]);

  // ══════════════════════════════════════════════════════════════════════════
  // NEW: Hierarchy API fetches
  // ══════════════════════════════════════════════════════════════════════════

  const manualAddTopicOptions = useMemo(() => {
    if (!testIdFromList || !selectedSubSubjectId) return [];

    return hierarchyTopics
      .filter(
        (topic) =>
          Boolean(topic?._id) &&
          !topic.isSynthetic &&
          String(topic._id) !== '__unassigned__' &&
          (!hierarchyChapterFilter ||
            String(topic.chapterId) === String(hierarchyChapterFilter)),
      )
      .sort((a, b) => {
        const chapterCompare = String(a.chapterName || '').localeCompare(
          String(b.chapterName || ''),
        );

        if (chapterCompare !== 0) return chapterCompare;

        return String(a.name || '').localeCompare(String(b.name || ''));
      })
      .map((topic) => ({
        ...topic,
        label:
          hierarchyChapterFilter || !topic.chapterName
            ? topic.name
            : `${topic.chapterName} > ${topic.name}`,
      }));
  }, [
    hierarchyChapterFilter,
    hierarchyTopics,
    selectedSubSubjectId,
    testIdFromList,
  ]);

  const selectedManualAddTopic = useMemo(
    () =>
      manualAddTopicOptions.find(
        (topic) => String(topic._id) === String(manualAddTopicId),
      ) || null,
    [manualAddTopicId, manualAddTopicOptions],
  );

  const fetchSubjects = useCallback(async () => {
    setSubjectsLoading(true);
    try {
      const res = await axios.get(`${baseUrl}/api/admin/subjects`, axiosConfig);
      setSubjects(res.data?.data ?? []);
    } catch (err) {
      console.error('Failed to fetch subjects:', err);
    } finally {
      setSubjectsLoading(false);
    }
  }, [baseUrl, axiosConfig]);

  const fetchSubSubjects = useCallback(
    async (subjectId) => {
      if (!subjectId) {
        setSubSubjects([]);
        return;
      }
      setSubSubjectsLoading(true);
      try {
        const res = await axios.get(
          `${baseUrl}/api/admin/sub-subjects?subjectId=${subjectId}`,
          axiosConfig,
        );
        setSubSubjects(res.data?.data ?? []);
      } catch (err) {
        console.error('Failed to fetch sub-subjects:', err);
        setSubSubjects([]);
      } finally {
        setSubSubjectsLoading(false);
      }
    },
    [baseUrl, axiosConfig],
  );

  const fetchHierarchyChapters = useCallback(
    async (subSubjectId) => {
      if (!subSubjectId) {
        setHierarchyChapters([]);
        setHierarchyTopics([]);
        setHierarchyTotalMcqs(0);
        return;
      }
      setHierarchyChaptersLoading(true);
      try {
        const params = appendContextFilters(
          new URLSearchParams({ subSubjectId }),
        );
        const res = await axios.get(
          `${baseUrl}/api/admin/mcqs/hierarchy-summary?${params.toString()}`,
          axiosConfig,
        );
        const summaryRows = res.data?.data ?? [];
        setHierarchyTotalMcqs(Number(res.data?.totalMcqs || 0));

        setHierarchyChapters(
          summaryRows.map((item) => ({
            ...item.chapter,
            mcqCount: item.mcqCount ?? 0,
            topicCount: item.topicCount ?? 0,
            activeTopicCount: item.activeTopicCount ?? 0,
            tags: Array.isArray(item.tags) ? item.tags : [],
          })),
        );

        setHierarchyTopics(
          summaryRows.flatMap((item) =>
            (item.topics ?? []).map((topic) => ({
              ...topic,
              chapterId: topic.chapterId || item.chapter._id,
              chapterName: item.chapter.name,
              mcqCount: topic.mcqCount ?? 0,
              isSynthetic: Boolean(topic.isSynthetic),
              tags: Array.isArray(topic.tags) ? topic.tags : [],
            })),
          ),
        );
      } catch (err) {
        console.error('Failed to fetch hierarchy chapters:', err);
        setHierarchyChapters([]);
        setHierarchyTopics([]);
        setHierarchyTotalMcqs(0);
      } finally {
        setHierarchyChaptersLoading(false);
      }
    },
    [baseUrl, axiosConfig, appendContextFilters],
  );

  // ══════════════════════════════════════════════════════════════════════════
  // ORIGINAL: fetchChapters (for Q-test list filter — preserved unchanged)
  // ══════════════════════════════════════════════════════════════════════════

  const fetchChapters = useCallback(async () => {
    if (!isQTestListPage) return;
    setChaptersLoading(true);
    setChaptersError('');
    try {
      const res = await axios.get(`${baseUrl}/api/admin/chapters`, axiosConfig);
      setChapters(res.data?.data ?? []);
    } catch (err) {
      console.error('Failed to fetch chapters:', err);
      setChaptersError(
        err?.response?.data?.message || 'Failed to load chapters.',
      );
    } finally {
      setChaptersLoading(false);
    }
  }, [axiosConfig, baseUrl, isQTestListPage]);

  // 🔥 FETCH TOPICS BY CHAPTER
  const fetchTopics = useCallback(
    async (chapterId) => {
      if (!chapterId) {
        setTopics([]);
        return;
      }

      setTopicsLoading(true);

      try {
        const res = await axios.get(
          `${baseUrl}/api/admin/topics?chapterId=${chapterId}`,
          axiosConfig,
        );
        setTopics(res.data?.data ?? []);
      } catch (err) {
        console.error('Failed to fetch topics:', err);
        setTopics([]);
      } finally {
        setTopicsLoading(false);
      }
    },
    [axiosConfig, baseUrl],
  );

  // 🔥 FETCH MCQs BY HIERARCHY (Chapter + Topic)
  const fetchMcqsByHierarchy = useCallback(async () => {
    if (!selectedChapterId) {
      setError('Please select a chapter');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const params = appendContextFilters(
        new URLSearchParams({
          chapterId: selectedChapterId,
        }),
      );

      if (selectedTopicId) {
        params.append('topicId', selectedTopicId);
      }

      const url = `${baseUrl}/api/admin/mcqs/by-hierarchy?${params.toString()}`;
      console.log('Fetching MCQs by hierarchy:', url);

      const res = await axios.get(url, axiosConfig);
      const data = res.data?.data ?? [];

      // Convert flat list to test-wise-grouped format for display
      setTestsWithMcqs([
        {
          testId: null,
          testName: selectedTopicId
            ? 'Filtered MCQs (Chapter > Topic)'
            : 'Filtered MCQs (Chapter)',
          testMode: null,
          totalMCQs: data.length,
          mcqList: data,
        },
      ]);

      setTotalMcqCount(data.length);

      if (data.length === 0) {
        setError('No MCQs found for the selected chapter/topic');
      }
    } catch (err) {
      console.error('Failed to fetch MCQs:', err);
      setTestsWithMcqs([]);
      setError(
        err?.response?.data?.message ||
          'Failed to fetch MCQs. Please try again.',
      );
    } finally {
      setLoading(false);
    }
  }, [
    baseUrl,
    axiosConfig,
    appendContextFilters,
    selectedChapterId,
    selectedTopicId,
  ]);

  // ══════════════════════════════════════════════════════════════════════════
  // ORIGINAL: fetchMcqsTestWise (preserved unchanged)
  // ══════════════════════════════════════════════════════════════════════════

  const fetchMcqsTestWise = useCallback(
    async (overrides = {}) => {
      const effectivePage = overrides.page ?? page;
      const effectiveChapterId = Object.prototype.hasOwnProperty.call(
        overrides,
        'chapterId',
      )
        ? overrides.chapterId
        : selectedChapterId;
      const effectiveTopicId = Object.prototype.hasOwnProperty.call(
        overrides,
        'topicId',
      )
        ? overrides.topicId
        : selectedTopicId;

      setLoading(true);
      setError('');
      try {
        const params = new URLSearchParams({
          page: String(effectivePage),
          limit: String(limit),
        });

        if (mode === 'manual') {
          params.set('testId', 'null');
        } else if (testIdFromList) {
          params.set('testId', testIdFromList);
        } else if (mode === 'exam') {
          params.set('testMode', 'exam');
        } else if (mode === 'regular') {
          params.set('testMode', 'regular');
        }

        if (isQTestListPage && effectiveChapterId) {
          params.set('chapterId', effectiveChapterId);
        }

        if (isQTestListPage && effectiveTopicId) {
          params.set('topicId', effectiveTopicId);
        }

        const url = `${baseUrl}/api/admin/mcqs?${params.toString()}`;
        console.log('Fetching MCQ URL:', url);
        const res = await axios.get(url, axiosConfig);
        const data = res.data?.data ?? [];
        const pagination = res.data?.pagination || {};

        if (res.data?.format === 'test-wise-grouped' && Array.isArray(data)) {
          setTestsWithMcqs(data);
          setTotalPages(pagination.totalPages || 1);
          setTotalMcqCount(pagination.total || 0);
          if (data.length === 1) setExpandedTestId(data[0].testId ?? 'manual');
        } else {
          setTestsWithMcqs([]);
          setTotalPages(1);
          setTotalMcqCount(0);
        }
      } catch (err) {
        console.error('Failed to fetch MCQs:', err);
        setTestsWithMcqs([]);
        setTotalPages(1);
        setTotalMcqCount(0);
        setError(
          err?.response?.data?.message ||
            'Failed to fetch MCQs. Please try again.',
        );
      } finally {
        setLoading(false);
      }
    },
    [
      baseUrl,
      axiosConfig,
      isQTestListPage,
      testIdFromList,
      mode,
      selectedChapterId,
      selectedTopicId,
      page,
      limit,
    ],
  );

  // ── Effects ────────────────────────────────────────────────────────────────

  // ORIGINAL: reset on route change
  useEffect(() => {
    setExpandedTestId(null);
    setExpandedChapterKey(null);
    setPage(1);
    setSelectedChapterId('');
    setSelectedTopicId('');
    setChapters([]);
    setTopics([]);
    setChaptersError('');
    setTestsWithMcqs([]);
    setTotalPages(1);
    setTotalMcqCount(0);
    setError('');
    setMcqIdInput('');
    setManualAddTopicId('');
    setSelectedSubjectId('');
    setSelectedSubSubjectId('');
    setHierarchySelectedChapterId('');
    setHierarchySelectedTopicId('');
    setSelectedSubjectName('');
    setSelectedSubSubjectName('');
    setSelectedChapterName('');
    setSelectedTopicName('');
    setHierarchyChapters([]);
    setHierarchyTopics([]);
    setHierarchyChapterFilter('');
    setHierarchySearch('');
    setHierarchyTotalMcqs(0);
    setHierarchyView('browser');
    setSelectedTestContext(null);
    setSelectedTestContextLoading(Boolean(testIdFromList));
    setSelectedTestContextError('');
    setPendingBranchSelection(null);
    setHasAppliedBranchSelection(false);
  }, [location.key, testIdFromList]);

  // ORIGINAL: load Q-test chapters
  useEffect(() => {
    if (!isQTestListPage) return;
    fetchChapters();
  }, [fetchChapters, isQTestListPage, location.key]);

  // ORIGINAL: refetch on page change
  useEffect(() => {
    fetchMcqsTestWise();
  }, [page, fetchMcqsTestWise, location.key]);

  // 🔥 FETCH TOPICS WHEN CHAPTER CHANGES
  useEffect(() => {
    if (selectedChapterId) {
      fetchTopics(selectedChapterId);
      setSelectedTopicId(''); // Reset topic selection
    } else {
      setTopics([]);
      setSelectedTopicId('');
    }
  }, [selectedChapterId, fetchTopics]);

  // NEW: load subjects on mount
  useEffect(() => {
    fetchSubjects();
  }, [fetchSubjects]);

  // NEW: load sub-subjects when subject changes
  useEffect(() => {
    setSelectedSubSubjectId('');
    setSubSubjectName_helper('');
    setHierarchyChapters([]);
    setHierarchyTopics([]);
    setHierarchyChapterFilter('');
    setHierarchySearch('');
    setHierarchyTotalMcqs(0);
    fetchSubSubjects(selectedSubjectId);
  }, [selectedSubjectId, fetchSubSubjects]);

  // NEW: load chapters+topics when sub-subject changes
  useEffect(() => {
    setHierarchyChapterFilter('');
    setHierarchySearch('');
    fetchHierarchyChapters(selectedSubSubjectId);
  }, [selectedSubSubjectId, fetchHierarchyChapters]);

  useEffect(() => {
    if (
      manualAddTopicId &&
      !manualAddTopicOptions.some(
        (topic) => String(topic._id) === String(manualAddTopicId),
      )
    ) {
      setManualAddTopicId('');
      setMcqIdInput('');
    }
  }, [manualAddTopicId, manualAddTopicOptions]);

  useEffect(() => {
    if (!pendingBranchSelection || hasAppliedBranchSelection) return;

    if (
      pendingBranchSelection.subjectId &&
      String(selectedSubjectId) !== String(pendingBranchSelection.subjectId)
    ) {
      setSelectedSubjectId(pendingBranchSelection.subjectId);
      setHierarchyView('browser');
      return;
    }

    if (
      pendingBranchSelection.subSubjectId &&
      String(selectedSubSubjectId) !==
        String(pendingBranchSelection.subSubjectId)
    ) {
      const hasSubSubjectMatch = visibleSubSubjectOptions.some(
        (item) =>
          String(item._id) === String(pendingBranchSelection.subSubjectId),
      );

      if (!hasSubSubjectMatch) return;

      setSelectedSubSubjectId(pendingBranchSelection.subSubjectId);
      setHierarchyView('browser');
      return;
    }

    if (selectedTestContext?.testMode === 'regular') {
      const desiredChapterId = pendingBranchSelection.chapterId || '';

      if (
        pendingBranchSelection.subSubjectId &&
        String(selectedSubSubjectId) !==
          String(pendingBranchSelection.subSubjectId)
      ) {
        return;
      }

      if (hierarchyChapterFilter !== desiredChapterId) {
        setHierarchyChapterFilter(desiredChapterId);
        return;
      }
    }

    setHasAppliedBranchSelection(true);
  }, [
    hasAppliedBranchSelection,
    hierarchyChapterFilter,
    pendingBranchSelection,
    selectedSubjectId,
    selectedSubSubjectId,
    selectedTestContext?.testMode,
    visibleSubSubjectOptions,
  ]);

  // helper setter (avoids lint warning on direct string set inside effect)
  const [, setSubSubjectName_helper] = useState('');

  const handleSelectTestBranch = useCallback(
    (branch) => {
      if (!branch) return;

      setHierarchyView('browser');
      setHierarchySelectedChapterId('');
      setHierarchySelectedTopicId('');
      setSelectedSubjectName('');
      setSelectedSubSubjectName('');
      setSelectedChapterName('');
      setSelectedTopicName('');
      setHierarchyChapterFilter('');
      setHierarchySearch('');
      setPendingBranchSelection({
        subjectId: branch.subjectId || '',
        subSubjectId: branch.subSubjectId || '',
        chapterId:
          selectedTestContext?.testMode === 'regular'
            ? branch.primaryChapterId || ''
            : '',
      });
      setHasAppliedBranchSelection(false);
    },
    [selectedTestContext?.testMode],
  );

  // ══════════════════════════════════════════════════════════════════════════
  // ORIGINAL helpers (ALL preserved)
  // ══════════════════════════════════════════════════════════════════════════

  const getDifficultyColor = (diff) => {
    if (diff === 'easy') return 'green';
    if (diff === 'medium') return 'yellow';
    if (diff === 'hard') return 'red';
    return 'gray';
  };

  const getImageUrl = (path) => {
    if (!path) return '';
    if (path.startsWith('http')) return path;
    const cleanPath = path.startsWith('/') ? path.slice(1) : path;
    return `${baseUrl}/${cleanPath}`;
  };

  const openModal = (mcq) => {
    setSelectedMcq(mcq);
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setSelectedMcq(null);
    setIsModalOpen(false);
  };

  const getPrimaryTestId = (mcq) => {
    const rawTestId = mcq?.testId;

    if (Array.isArray(rawTestId)) {
      const firstTest = rawTestId[0];
      return firstTest?._id || firstTest || '';
    }

    return rawTestId?._id || rawTestId || '';
  };

  const openEditMcqInNewTab = (mcq) => {
    if (!mcq?._id) return;

    const editMode = mcq.testMode || mode || 'manual';
    const params = new URLSearchParams({ editMcqId: mcq._id });
    const primaryTestId = getPrimaryTestId(mcq) || testIdFromList;

    if (primaryTestId) {
      params.set('testId', primaryTestId);
    }

    window.open(
      `/admin/mcq/${editMode}?${params.toString()}`,
      '_blank',
      'noopener,noreferrer',
    );
  };

  const handleDeleteMcq = async (mcqId) => {
    if (!window.confirm('Are you sure you want to delete this MCQ?')) return;
    try {
      await axios.delete(`${baseUrl}/api/admin/mcqs/${mcqId}`, axiosConfig);
      setPage(1);
      fetchMcqsTestWise();
    } catch (err) {
      console.error(err);
      alert(err.response?.data?.message || 'Failed to delete MCQ');
    }
  };

  const handleAddMcqToTest = async () => {
    if (!testIdFromList) {
      alert('Test not found');
      return;
    }

    if (!manualAddTopicId) {
      alert('Please select a topic first');
      return;
    }

    if (!mcqIdInput.trim()) {
      alert('Please enter a valid MCQ ID');
      return;
    }
    try {
      setAddingMcq(true);
      await axios.post(
        `${baseUrl}/api/admin/tests/${testIdFromList}/add-mcq-by-codon`,
        {
          codonId: mcqIdInput.trim(),
          topicId: manualAddTopicId,
        },
        axiosConfig,
      );
      setMcqIdInput('');
      setPage(1);
      await Promise.all([
        fetchSelectedTestContext(),
        selectedSubSubjectId
          ? fetchHierarchyChapters(selectedSubSubjectId)
          : Promise.resolve(),
      ]);
      fetchMcqsTestWise();
    } catch (err) {
      console.error(err);
      alert(err.response?.data?.message || 'Failed to add MCQ');
    } finally {
      setAddingMcq(false);
    }
  };

  // ORIGINAL: group MCQs by hierarchy
  const groupByHierarchy = (mcqList) =>
    mcqList.reduce((acc, mcq) => {
      const subject = mcq.subjectId?.name || 'Uncategorized';
      const subSubject = mcq.subSubjectId?.name || 'General';
      const chapter = mcq.chapterId?.name || 'No Chapter';
      const topic = mcq.topicId?.name || 'Miscellaneous';
      if (!acc[subject]) acc[subject] = {};
      if (!acc[subject][subSubject]) acc[subject][subSubject] = {};
      if (!acc[subject][subSubject][chapter])
        acc[subject][subSubject][chapter] = {};
      if (!acc[subject][subSubject][chapter][topic])
        acc[subject][subSubject][chapter][topic] = [];
      acc[subject][subSubject][chapter][topic].push(mcq);
      return acc;
    }, {});

  // ══════════════════════════════════════════════════════════════════════════
  // NEW: Hierarchy Browser computed rows
  // ══════════════════════════════════════════════════════════════════════════

  const formatMcqCountLabel = useCallback(
    (count) => `${count} ${count === 1 ? 'MCQ' : 'MCQs'}`,
    [],
  );

  /** Build all chapter-topic rows for the selected sub-subject */
  const allHierarchyRows = useMemo(() => {
    if (!selectedSubSubjectId) return [];
    const rows = [];
    hierarchyChapters.forEach((ch) => {
      const chapterTopics = hierarchyTopics.filter(
        (t) => String(t.chapterId) === String(ch._id),
      );

      rows.push({
        chapter: ch,
        topic: null,
        mcqCount: ch.mcqCount ?? 0,
        tags: Array.isArray(ch.tags) ? ch.tags : [],
        activeTopicCount: ch.activeTopicCount ?? 0,
        isChapterWide: true,
      });

      chapterTopics.forEach((topic) =>
        rows.push({
          chapter: ch,
          topic,
          mcqCount: topic.mcqCount ?? 0,
          tags: Array.isArray(topic.tags) ? topic.tags : [],
          activeTopicCount: ch.activeTopicCount ?? 0,
          isSyntheticTopic: Boolean(topic.isSynthetic),
          isChapterWide: false,
        }),
      );
    });
    return rows;
  }, [selectedSubSubjectId, hierarchyChapters, hierarchyTopics]);

  /** Apply chapter dropdown filter + search */
  const filteredHierarchyRows = useMemo(() => {
    return allHierarchyRows.filter((row) => {
      const chapterMatch =
        !hierarchyChapterFilter || row.chapter._id === hierarchyChapterFilter;
      const searchLow = hierarchySearch.toLowerCase();
      const searchMatch =
        !searchLow ||
        row.chapter.name.toLowerCase().includes(searchLow) ||
        (row.topic?.name || '').toLowerCase().includes(searchLow) ||
        (row.tags || []).some((tag) => tag.toLowerCase().includes(searchLow));
      return chapterMatch && searchMatch;
    });
  }, [allHierarchyRows, hierarchyChapterFilter, hierarchySearch]);

  const filteredHierarchyMcqCount = useMemo(
    () =>
      filteredHierarchyRows.reduce(
        (sum, row) => sum + Number(row.mcqCount || 0),
        0,
      ),
    [filteredHierarchyRows],
  );

  /** Open MCQ detail view for a specific chapter + topic row */
  const handleViewMCQs = (row) => {
    setSelectedSubjectName(currentSubjectName || '');
    setSelectedSubSubjectName(currentSubSubjectName || '');
    setSelectedChapterName(row.chapter.name);
    setHierarchySelectedChapterId(row.chapter._id);
    setHierarchySelectedTopicId(row.isChapterWide ? '' : row.topic?._id || '');
    setSelectedTopicName(row.topic?.name || 'All Topics');
    setHierarchyMcqSearch('');
    setHierarchyView('mcq');
  };

  // ══════════════════════════════════════════════════════════════════════════
  // NEW: MCQ detail page — fetch MCQs for selected chapter + topic
  // ══════════════════════════════════════════════════════════════════════════

  const [hierarchyMcqs, setHierarchyMcqs] = useState([]);
  const [hierarchyMcqsLoading, setHierarchyMcqsLoading] = useState(false);
  const [hierarchyMcqsError, setHierarchyMcqsError] = useState('');
  const [hierarchyMcqSearch, setHierarchyMcqSearch] = useState('');
  const [shownAnswers, setShownAnswers] = useState({});

  useEffect(() => {
    setHierarchyMcqs([]);
    setHierarchyMcqsLoading(false);
    setHierarchyMcqsError('');
    setHierarchyMcqSearch('');
    setShownAnswers({});
  }, [location.key]);

  const fetchHierarchyMcqs = useCallback(async () => {
    if (!hierarchySelectedChapterId) return;
    setHierarchyMcqsLoading(true);
    setHierarchyMcqsError('');
    setShownAnswers({});
    try {
      const params = appendContextFilters(
        new URLSearchParams({
          chapterId: hierarchySelectedChapterId,
        }),
      );
      if (hierarchySelectedTopicId) {
        params.set('topicId', hierarchySelectedTopicId);
      }
      const res = await axios.get(
        `${baseUrl}/api/admin/mcqs/by-hierarchy?${params.toString()}`,
        axiosConfig,
      );
      setHierarchyMcqs(res.data?.data ?? []);
    } catch (err) {
      console.error('Failed to fetch hierarchy MCQs:', err);
      setHierarchyMcqsError(
        err?.response?.data?.message || 'Failed to load MCQs.',
      );
      setHierarchyMcqs([]);
    } finally {
      setHierarchyMcqsLoading(false);
    }
  }, [
    baseUrl,
    axiosConfig,
    appendContextFilters,
    hierarchySelectedChapterId,
    hierarchySelectedTopicId,
  ]);

  useEffect(() => {
    if (hierarchyView === 'mcq') fetchHierarchyMcqs();
  }, [hierarchyView, fetchHierarchyMcqs]);

  const getHierarchyMcqTags = useCallback((mcq) => {
    const tagNames = new Set();

    (mcq?.tags || []).filter(Boolean).forEach((tag) => tagNames.add(tag));

    if (Array.isArray(mcq?.tagId)) {
      mcq.tagId.forEach((tag) => {
        if (tag?.name) tagNames.add(tag.name);
      });
    } else if (mcq?.tagId?.name) {
      tagNames.add(mcq.tagId.name);
    }

    if (mcq?.previousYearTag) {
      tagNames.add('Previous Year');
    }

    return Array.from(tagNames);
  }, []);

  const filteredHierarchyMcqs = useMemo(() => {
    const searchValue = hierarchyMcqSearch.trim().toLowerCase();

    if (!searchValue) return hierarchyMcqs;

    return hierarchyMcqs.filter((mcq) => {
      const searchableParts = [
        mcq.codonId,
        mcq.question?.text,
        mcq.chapterId?.name,
        mcq.topicId?.name,
        ...getHierarchyMcqTags(mcq),
        ...((mcq.options || []).map((opt) =>
          typeof opt === 'string' ? opt : opt?.text,
        ) || []),
      ]
        .filter(Boolean)
        .join(' ')
        .toLowerCase();

      return searchableParts.includes(searchValue);
    });
  }, [getHierarchyMcqTags, hierarchyMcqSearch, hierarchyMcqs]);

  const hierarchyMcqTagSummary = useMemo(() => {
    const tagCountMap = new Map();

    hierarchyMcqs.forEach((mcq) => {
      getHierarchyMcqTags(mcq).forEach((tagName) => {
        tagCountMap.set(tagName, (tagCountMap.get(tagName) || 0) + 1);
      });
    });

    return Array.from(tagCountMap.entries())
      .sort((a, b) => b[1] - a[1] || a[0].localeCompare(b[0]))
      .map(([name, count]) => ({ name, count }));
  }, [getHierarchyMcqTags, hierarchyMcqs]);

  const toggleAnswer = (id) =>
    setShownAnswers((prev) => ({ ...prev, [id]: !prev[id] }));

  // ══════════════════════════════════════════════════════════════════════════
  // RENDER: NEW Hierarchy Browser Panel
  // ══════════════════════════════════════════════════════════════════════════

  const renderHierarchyBrowser = () => (
    <Card
      bg={hierarchyPanelBg}
      shadow="lg"
      borderRadius="2xl"
      overflow="hidden"
      border="1px solid"
      borderColor={hierarchyPanelBorder}
      maxW="1400px"
      mx="auto"
      mb={8}
    >
      <CardHeader bg={headerBg} py={5} px={{ base: 5, md: 8 }}>
        <HStack spacing={3}>
          <Icon as={MdSchool} boxSize={6} color={accentColor} />
          <Heading size="md" color={accentColor}>
            {hierarchyTitle}
          </Heading>
        </HStack>
        <Text fontSize="xs" color={secondaryText} mt={1} display="none">
          Subject → Sub-Subject → Chapter → Topic → MCQ
        </Text>
       <HStack spacing={2} mt={1} justify="space-between" align="center">
          <Text fontSize="xs" color={secondaryText}>
            {hierarchySubtitle}
          </Text>
          <Tooltip label="Refresh data">
            <Button
              size="xs"
              variant="ghost"
              colorScheme="purple"
              onClick={() => {
                fetchSubjects();
                if (selectedSubjectId) fetchSubSubjects(selectedSubjectId);
                if (selectedSubSubjectId) fetchHierarchyChapters(selectedSubSubjectId);
              }}
            >
              🔄Refresh
            </Button>
          </Tooltip>
        </HStack>
        <HStack spacing={3} flexWrap="wrap" mt={3}>
          <Badge
            colorScheme={mode === 'exam' ? 'orange' : 'purple'}
            px={3}
            py={1}
            borderRadius="full"
          >
            {mode === 'exam'
              ? 'Exam Mode Only'
              : mode === 'regular'
                ? 'Regular Mode Only'
                : 'All MCQs'}
          </Badge>
          <Badge
            colorScheme="blue"
            variant="subtle"
            px={3}
            py={1}
            borderRadius="full"
          >
            {hierarchyChapters.length} Chapters
          </Badge>
          <Badge
            colorScheme="cyan"
            variant="subtle"
            px={3}
            py={1}
            borderRadius="full"
          >
            {hierarchyTopics.length} Topics
          </Badge>
          <Badge colorScheme="purple" px={3} py={1} borderRadius="full">
            {hierarchyTotalMcqs} Total MCQs
          </Badge>
        </HStack>
      </CardHeader>

      <CardBody p={{ base: 4, md: 6 }}>
        {testIdFromList && (
          <Box
            mb={6}
            p={4}
            bg={addMcqContainerBg}
            border="1px solid"
            borderColor={borderColor}
            borderRadius="xl"
          >
            <VStack align="stretch" spacing={4}>
              <HStack
                justify="space-between"
                align="start"
                flexWrap="wrap"
                gap={3}
              >
                <VStack align="start" spacing={1}>
                  <Text
                    fontSize="xs"
                    fontWeight="600"
                    color={accentColor}
                    textTransform="uppercase"
                    letterSpacing="wider"
                  >
                    Selected Test Overview
                  </Text>
                  <Heading size="sm">
                    {selectedTestContext?.title || 'Loading selected test...'}
                  </Heading>
                  <Text fontSize="sm" color={secondaryText}>
                    {selectedTestContext?.courseName ||
                      'Course details unavailable'}
                  </Text>
                </VStack>
                <HStack spacing={2} flexWrap="wrap">
                  <Badge
                    colorScheme={
                      (selectedTestContext?.testMode || mode) === 'exam'
                        ? 'orange'
                        : 'purple'
                    }
                    px={3}
                    py={1}
                    borderRadius="full"
                    textTransform="capitalize"
                  >
                    {selectedTestContext?.testMode || mode}
                  </Badge>
                  <Badge colorScheme="purple" px={3} py={1} borderRadius="full">
                    {selectedTestContext?.totalQuestions ?? 0} MCQs
                  </Badge>
                </HStack>
              </HStack>

              {selectedTestContextLoading ? (
                <HStack spacing={3}>
                  <Spinner size="sm" color={accentColor} />
                  <Text fontSize="sm" color={secondaryText}>
                    Loading test hierarchy context...
                  </Text>
                </HStack>
              ) : selectedTestContextError ? (
                <Text fontSize="sm" color="red.400">
                  {selectedTestContextError}
                </Text>
              ) : resolvedTestBranches.length === 0 ? (
                <Text fontSize="sm" color={secondaryText}>
                  This test does not have a linked subject/sub-subject context
                  yet.
                </Text>
              ) : (
                <SimpleGrid columns={{ base: 1, md: 2 }} spacing={3}>
                  {resolvedTestBranches.map((branch) => {
                    const branchKey = `${branch.subjectId}::${branch.subSubjectId}`;
                    const isActive = activeTestBranchKey === branchKey;
                    const chapterPreview = branch.chapterNames
                      .filter(Boolean)
                      .slice(0, 3);
                    const topicPreview = branch.topicNames
                      .filter(Boolean)
                      .slice(0, 3);

                    return (
                      <Box
                        key={branchKey}
                        p={4}
                        borderRadius="xl"
                        border="1px solid"
                        borderColor={isActive ? 'purple.300' : borderColor}
                        bg={isActive ? 'purple.50' : hierarchyPanelBg}
                      >
                        <VStack align="stretch" spacing={3}>
                          <HStack justify="space-between" align="start" gap={3}>
                            <VStack align="start" spacing={1}>
                              <Text fontSize="sm" fontWeight="600">
                                {branch.subjectName}
                              </Text>
                              <Text fontSize="sm" color={secondaryText}>
                                {branch.subSubjectName}
                              </Text>
                            </VStack>
                            <Badge
                              colorScheme={isActive ? 'purple' : 'gray'}
                              px={2}
                              py={1}
                              borderRadius="full"
                            >
                              {branch.mcqCount} MCQs
                            </Badge>
                          </HStack>

                          <Text fontSize="xs" color={secondaryText}>
                            {branch.chapterCount} chapters / {branch.topicCount}{' '}
                            topics
                          </Text>

                          {branch.primaryChapterName && (
                            <Text fontSize="xs" color={secondaryText}>
                              Primary chapter: {branch.primaryChapterName}
                            </Text>
                          )}

                          {chapterPreview.length > 0 && (
                            <Wrap spacing={2}>
                              {chapterPreview.map((chapterName) => (
                                <WrapItem key={`${branchKey}-${chapterName}`}>
                                  <Badge
                                    colorScheme="purple"
                                    variant="subtle"
                                    px={2}
                                    py={1}
                                    borderRadius="md"
                                    fontSize="xs"
                                  >
                                    {chapterName}
                                  </Badge>
                                </WrapItem>
                              ))}
                            </Wrap>
                          )}

                          {topicPreview.length > 0 && (
                            <Wrap spacing={2}>
                              {topicPreview.map((topicName) => (
                                <WrapItem key={`${branchKey}-${topicName}`}>
                                  <Badge
                                    colorScheme="blue"
                                    variant="subtle"
                                    px={2}
                                    py={1}
                                    borderRadius="md"
                                    fontSize="xs"
                                  >
                                    {topicName}
                                  </Badge>
                                </WrapItem>
                              ))}
                            </Wrap>
                          )}

                          {/* <Button
                            size="sm"
                            alignSelf="flex-start"
                            colorScheme="purple"
                            variant={isActive ? 'solid' : 'outline'}
                            onClick={() => handleSelectTestBranch(branch)}
                          >
                            {isActive ? 'Showing Branch' : 'Show Branch'}
                          </Button> */}
                        </VStack>
                      </Box>
                    );
                  })}
                </SimpleGrid>
              )}

              <Box
                pt={6}
                pb={5}
                px={5}
                borderTop="1px dashed"
                borderColor={borderColor}
                bg="whiteAlpha.50"
                borderRadius="xl"
                boxShadow="sm"
              >
                <VStack align="stretch" spacing={5}>
                  {/* Header */}
                  <HStack spacing={3}>
                    <Flex
                      w={8}
                      h={8}
                      bg="blue.50"
                      color="blue.600"
                      borderRadius="lg"
                      align="center"
                      justify="center"
                    >
                      <Icon as={MdTopic} boxSize={5} />
                    </Flex>

                    <Box>
                      <Text fontSize="md" fontWeight="700" color="gray.800">
                        Add MCQ to Topic
                      </Text>
                      <Text fontSize="xs" color="gray.500">
                        Manually add MCQ using Codon ID
                      </Text>
                    </Box>
                  </HStack>

                  {/* Topic Selector */}
                  <VStack align="stretch" spacing={2}>
                    <Text fontSize="sm" fontWeight="600" color="gray.700">
                      Select Topic
                    </Text>

                    <Select
                      size="md"
                      value={manualAddTopicId}
                      onChange={(e) => {
                        setManualAddTopicId(e.target.value);
                        setMcqIdInput('');
                      }}
                      bg="white"
                      borderRadius="lg"
                      focusBorderColor="blue.500"
                      isDisabled={
                        selectedTestContextLoading ||
                        hierarchyChaptersLoading ||
                        !selectedSubSubjectId
                      }
                      _hover={{ borderColor: 'gray.300' }}
                    >
                      <option value="">
                        {selectedSubSubjectId
                          ? manualAddTopicOptions.length > 0
                            ? 'Choose a topic...'
                            : hierarchyChaptersLoading
                              ? 'Loading topics...'
                              : 'No topics available'
                          : 'First select Subject & Sub-subject'}
                      </option>
                      {manualAddTopicOptions.map((topic) => (
                        <option key={topic._id} value={topic._id}>
                          {topic.label}
                        </option>
                      ))}
                    </Select>

                    {/* Helper Messages */}
                    {!selectedSubSubjectId ? (
                      <Text
                        fontSize="xs"
                        color="orange.600"
                        fontWeight="medium"
                      >
                        Please select Subject and Sub-subject first
                      </Text>
                    ) : manualAddTopicOptions.length === 0 &&
                      !hierarchyChaptersLoading ? (
                      <Text fontSize="xs" color="red.500" fontWeight="medium">
                        No active topics found in this branch
                      </Text>
                    ) : null}
                  </VStack>

                  {/* Add MCQ Section - Only show when topic selected */}
                  {selectedManualAddTopic && (
                    <VStack
                      align="stretch"
                      spacing={3}
                      pt={3}
                      borderTop="1px solid"
                      borderColor="gray.100"
                    >
                      <HStack justify="space-between" align="center">
                        <Text fontSize="sm" fontWeight="600" color="gray.700">
                          Adding to:
                        </Text>
                        <Text
                          fontSize="sm"
                          fontWeight="600"
                          color="blue.600"
                          bg="blue.50"
                          px={3}
                          py={1}
                          borderRadius="full"
                        >
                          {selectedManualAddTopic.label}
                        </Text>
                      </HStack>

                      <HStack spacing={3}>
                        <Input
                          placeholder="Enter MCQ Codon ID (e.g. BIO12345)"
                          value={mcqIdInput}
                          onChange={(e) => setMcqIdInput(e.target.value)}
                          bg="white"
                          size="md"
                          borderRadius="lg"
                          focusBorderColor="blue.500"
                          _placeholder={{ color: 'gray.400' }}
                        />

                        <Button
                          colorScheme="green"
                          isLoading={addingMcq}
                          onClick={handleAddMcqToTest}
                          size="md"
                          px={8}
                          borderRadius="lg"
                          fontWeight="600"
                        >
                          Add MCQ
                        </Button>
                      </HStack>
                    </VStack>
                  )}
                </VStack>
              </Box>
            </VStack>
          </Box>
        )}
        {/* ── Step 1: Subjects ── */}
        <Box mb={5}>
          <HStack mb={3} spacing={2}>
            <Icon as={MdSchool} boxSize={4} color={subjectAccent} />
            <Text
              fontSize="xs"
              fontWeight="600"
              color={subjectAccent}
              textTransform="uppercase"
              letterSpacing="wider"
            >
              Subjects
            </Text>
            {subjectsLoading && <Spinner size="xs" color={accentColor} />}
          </HStack>
          {testIdFromList && selectedTestContextLoading ? (
            <Text fontSize="sm" color={secondaryText}>
              Loading test subjects...
            </Text>
          ) : visibleSubjects.length === 0 && !subjectsLoading ? (
            <Text fontSize="sm" color={secondaryText}>
              {testIdFromList
                ? 'No test-specific subjects are available yet.'
                : 'No subjects found.'}
            </Text>
          ) : (
            <Flex flexWrap="wrap" gap={2}>
              {visibleSubjects.map((s) => (
                <HierarchyChip
                  key={s._id}
                  label={s.name}
                  isSelected={String(selectedSubjectId) === String(s._id)}
                  onClick={() =>
                    setSelectedSubjectId(
                      String(selectedSubjectId) === String(s._id) ? '' : s._id,
                    )
                  }
                  colorScheme="purple"
                />
              ))}
            </Flex>
          )}
        </Box>

        {/* ── Step 2: Sub-Subjects (visible after subject selected) ── */}
        {selectedSubjectId && (
          <Box mb={5} pt={4} borderTop="1px dashed" borderColor={borderColor}>
            <HStack mb={3} spacing={2}>
              <Icon as={MdMenuBook} boxSize={4} color={subSubjectAccent} />
              <Text
                fontSize="xs"
                fontWeight="600"
                color={subSubjectAccent}
                textTransform="uppercase"
                letterSpacing="wider"
              >
                Sub-Subjects
              </Text>
              {subSubjectsLoading && <Spinner size="xs" color="blue.400" />}
            </HStack>
            {visibleSubSubjectOptions.length === 0 && !subSubjectsLoading ? (
              <Text fontSize="sm" color={secondaryText}>
                {testIdFromList
                  ? 'No test-specific sub-subjects found for this subject.'
                  : 'No sub-subjects found for this subject.'}
              </Text>
            ) : (
              <Flex flexWrap="wrap" gap={2}>
                {visibleSubSubjectOptions.map((ss) => (
                  <HierarchyChip
                    key={ss._id}
                    label={ss.name}
                    isSelected={String(selectedSubSubjectId) === String(ss._id)}
                    onClick={() =>
                      setSelectedSubSubjectId(
                        String(selectedSubSubjectId) === String(ss._id)
                          ? ''
                          : ss._id,
                      )
                    }
                    colorScheme="blue"
                  />
                ))}
              </Flex>
            )}
          </Box>
        )}

        {/* ── Step 3: Chapter/Topic Table (visible after sub-subject selected) ── */}
        {selectedSubSubjectId && (
          <Box pt={4} borderTop="1px dashed" borderColor={borderColor}>
            {/* Active context breadcrumb */}
            <HierarchyBreadcrumb
              subject={currentSubjectName}
              subSubject={currentSubSubjectName}
            />

            {/* Filters row */}
            <HStack mb={4} spacing={3} flexWrap="wrap">
              <Select
                size="sm"
                maxW="220px"
                value={hierarchyChapterFilter}
                onChange={(e) => setHierarchyChapterFilter(e.target.value)}
                bg={addMcqInputBg}
                borderRadius="lg"
                isDisabled={hierarchyChaptersLoading}
              >
                <option value="">All Chapters</option>
                {hierarchyChapters.map((ch) => (
                  <option key={ch._id} value={ch._id}>
                    {ch.name}
                  </option>
                ))}
              </Select>

              <InputGroup size="sm" maxW="280px">
                <InputLeftElement pointerEvents="none">
                  <Icon as={MdSearch} color="gray.400" boxSize={4} />
                </InputLeftElement>
                <Input
                  placeholder="Search chapter, topic, or tag..."
                  value={hierarchySearch}
                  onChange={(e) => setHierarchySearch(e.target.value)}
                  bg={addMcqInputBg}
                  borderRadius="lg"
                />
              </InputGroup>

              <Badge
                colorScheme="purple"
                px={3}
                py={1}
                borderRadius="full"
                fontSize="xs"
              >
                {filteredHierarchyRows.length} rows
              </Badge>
              <Badge
                colorScheme="blue"
                variant="subtle"
                px={3}
                py={1}
                borderRadius="full"
                fontSize="xs"
              >
                {formatMcqCountLabel(filteredHierarchyMcqCount)} visible
              </Badge>
            </HStack>

            {/* Table */}
            {hierarchyChaptersLoading ? (
              <Flex justify="center" py={10}>
                <VStack spacing={3}>
                  <Spinner size="md" color={accentColor} />
                  <Text fontSize="sm" color={secondaryText}>
                    Loading chapters & topics...
                  </Text>
                </VStack>
              </Flex>
            ) : filteredHierarchyRows.length === 0 ? (
              <Flex
                justify="center"
                align="center"
                direction="column"
                gap={3}
                py={10}
                border="1px dashed"
                borderColor={borderColor}
                borderRadius="xl"
              >
                <Icon as={MdFilterList} boxSize={8} color="gray.300" />
                <Text color={secondaryText} fontSize="sm">
                  No chapter-topic rows match your filter.
                </Text>
              </Flex>
            ) : (
              <Box
                border="1px solid"
                borderColor={borderColor}
                borderRadius="xl"
                overflow="hidden"
              >
                <Table variant="simple" size="md">
                  <Thead bg={tableBg}>
                    <Tr>
                      <Th width="50px">#</Th>
                      <Th>Chapter Name</Th>
                      <Th>Topic Name</Th>
                      <Th>Tags Name</Th>
                      <Th width="120px">MCQs</Th>
                      <Th width="170px">Action</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {filteredHierarchyRows.map((row, idx) => (
                      <Tr
                        key={`${row.chapter._id}-${row.topic?._id || 'no-topic'}-${idx}`}
                        bg={row.isChapterWide ? 'purple.50' : undefined}
                        _hover={{ bg: bgHover }}
                      >
                        <Td>
                          <Text
                            fontSize="xs"
                            color={secondaryText}
                            fontFamily="mono"
                          >
                            {idx + 1}
                          </Text>
                        </Td>
                        <Td minW="260px">
                          <VStack align="start" spacing={1}>
                            <Badge
                              colorScheme="purple"
                              variant="subtle"
                              px={2}
                              py={1}
                              borderRadius="md"
                              fontSize="xs"
                            >
                              {row.chapter.name}
                            </Badge>
                            <Text fontSize="xs" color={secondaryText}>
                              {`${row.chapter.topicCount || 0} topics in chapter`}
                            </Text>
                          </VStack>
                        </Td>
                        <Td minW="300px">
                          {row.topic ? (
                            <VStack align="start" spacing={1}>
                              <Text
                                fontSize="sm"
                                fontWeight="500"
                                color={
                                  row.isSyntheticTopic
                                    ? 'orange.500'
                                    : 'inherit'
                                }
                              >
                                {row.topic?.name || 'Unassigned topic'}
                              </Text>
                              <Text fontSize="xs" color={secondaryText}>
                                {row.isSyntheticTopic
                                  ? 'Topic mapping recovered from existing MCQ data'
                                  : 'Topic-level MCQ view'}
                              </Text>
                            </VStack>
                          ) : (
                            <>
                              <Text
                                fontSize="sm"
                                color={secondaryText}
                                fontStyle="italic"
                                display={row.isChapterWide ? 'none' : undefined}
                              >
                                —
                              </Text>
                              {row.isChapterWide ? (
                                <VStack align="start" spacing={1}>
                                  <Text fontSize="sm" fontWeight="600">
                                    All topics in this chapter
                                  </Text>
                                  <Text fontSize="xs" color={secondaryText}>
                                    {`${row.activeTopicCount || 0}/${row.chapter.topicCount || 0} topics currently have MCQs`}
                                  </Text>
                                </VStack>
                              ) : null}
                            </>
                          )}
                        </Td>
                        <Td minW="260px">
                          {row.tags?.length ? (
                            <Wrap spacing={2}>
                              {row.tags.map((tagName) => (
                                <WrapItem
                                  key={`${row.chapter._id}-${row.topic?._id || 'chapter'}-${tagName}`}
                                >
                                  <Badge
                                    colorScheme="teal"
                                    variant="subtle"
                                    px={2}
                                    py={1}
                                    borderRadius="md"
                                    fontSize="xs"
                                  >
                                    {tagName}
                                  </Badge>
                                </WrapItem>
                              ))}
                            </Wrap>
                          ) : (
                            <>
                              <Text
                                fontSize="sm"
                                color={secondaryText}
                                fontStyle="italic"
                                display="none"
                              >
                                —
                              </Text>
                              <Text
                                fontSize="sm"
                                color={secondaryText}
                                fontStyle="italic"
                              >
                                No tags
                              </Text>
                            </>
                          )}
                        </Td>
                        <Td>
                          <Badge
                            colorScheme={row.mcqCount > 0 ? 'purple' : 'gray'}
                            variant={row.mcqCount > 0 ? 'solid' : 'subtle'}
                            px={3}
                            py={1}
                            borderRadius="full"
                            fontSize="xs"
                          >
                            {formatMcqCountLabel(row.mcqCount)}
                          </Badge>
                        </Td>
                        <Td>
                          <Button
                            size="sm"
                            colorScheme={row.mcqCount > 0 ? 'purple' : 'gray'}
                            variant={row.mcqCount > 0 ? 'solid' : 'outline'}
                            borderRadius="lg"
                            rightIcon={<MdChevronRight />}
                            onClick={() => handleViewMCQs(row)}
                            isDisabled={row.mcqCount === 0}
                          >
                            {row.mcqCount === 0
                              ? 'No MCQs'
                              : row.isChapterWide
                                ? 'View Chapter MCQs'
                                : 'View Topic MCQs'}
                          </Button>
                        </Td>
                      </Tr>
                    ))}
                  </Tbody>
                </Table>
              </Box>
            )}
          </Box>
        )}

        {/* Placeholder when nothing is selected */}
        {!selectedSubjectId && (
          <Flex
            justify="center"
            align="center"
            direction="column"
            gap={3}
            py={8}
            mt={2}
            border="1px dashed"
            borderColor={borderColor}
            borderRadius="xl"
          >
            <Icon as={MdSchool} boxSize={10} color="gray.300" />
            <Text color={secondaryText} fontSize="sm">
              Select a subject above to browse chapters and topics.
            </Text>
          </Flex>
        )}
      </CardBody>
    </Card>
  );

  // ══════════════════════════════════════════════════════════════════════════
  // RENDER: NEW Hierarchy MCQ Detail Page
  // ══════════════════════════════════════════════════════════════════════════

  const renderHierarchyMCQPage = () => {
    const visibleHierarchyMcqs = filteredHierarchyMcqs;
    const hasHierarchySearch = Boolean(hierarchyMcqSearch.trim());
    const mcqStats = {
      total: visibleHierarchyMcqs.length,
      easy: visibleHierarchyMcqs.filter((m) => m.difficulty === 'easy').length,
      medium: visibleHierarchyMcqs.filter((m) => m.difficulty === 'medium')
        .length,
      hard: visibleHierarchyMcqs.filter((m) => m.difficulty === 'hard').length,
    };

    return (
      <Card
        bg={bgCard}
        shadow="lg"
        borderRadius="2xl"
        overflow="hidden"
        border="1px solid"
        borderColor={borderColor}
        maxW="1400px"
        mx="auto"
        mb={8}
      >
        <CardHeader bg={headerBg} py={5} px={{ base: 5, md: 8 }}>
          <VStack align="stretch" spacing={3}>
            {/* Back button */}
         <HStack justify="space-between" align="center">
              <Button
                size="sm"
                variant="ghost"
                colorScheme="gray"
                alignSelf="flex-start"
                leftIcon={<MdArrowBack />}
                onClick={() => {
                  setHierarchyView('browser');
                  setHierarchyMcqs([]);
                  setShownAnswers({});
                }}
              >
                {hierarchyBackLabel}
              </Button>
              <Tooltip label="Refresh MCQs">
                <Button
                  size="xs"
                  variant="ghost"
                  colorScheme="purple"
                  onClick={() => fetchHierarchyMcqs()}
                >
                  🔄Refresh
                </Button>
              </Tooltip>
            </HStack>

            {/* Breadcrumb */}
            <HierarchyBreadcrumb
              subject={selectedSubjectName}
              subSubject={selectedSubSubjectName}
              chapter={selectedChapterName}
              topic={selectedTopicName || undefined}
            />

            <HStack
              justify="space-between"
              align="center"
              flexWrap="wrap"
              gap={3}
            >
              <VStack align="start" spacing={0}>
                <Heading size="md" color={accentColor}>
                  {selectedChapterName}
                  {selectedTopicName ? ` › ${selectedTopicName}` : ''}
                </Heading>
                <Text fontSize="xs" color={secondaryText}>
                  {repositorySubtitle}
                </Text>
              </VStack>
              <Badge
                colorScheme="purple"
                px={4}
                py={2}
                borderRadius="lg"
                fontSize="md"
              >
                {hasHierarchySearch
                  ? `${formatMcqCountLabel(mcqStats.total)} Matching`
                  : formatMcqCountLabel(mcqStats.total)}
              </Badge>
            </HStack>

            {!hierarchyMcqsLoading && hierarchyMcqs.length > 0 && (
              <VStack align="stretch" spacing={3} pt={1}>
                <HStack flexWrap="wrap" spacing={3}>
                  <InputGroup size="sm" maxW="360px">
                    <InputLeftElement pointerEvents="none">
                      <Icon as={MdSearch} color="gray.400" boxSize={4} />
                    </InputLeftElement>
                    <Input
                      placeholder="Search by MCQ ID, question, option, tag..."
                      value={hierarchyMcqSearch}
                      onChange={(e) => setHierarchyMcqSearch(e.target.value)}
                      bg={addMcqInputBg}
                      borderRadius="lg"
                    />
                  </InputGroup>
                  <Badge
                    colorScheme="blue"
                    px={3}
                    py={1}
                    borderRadius="full"
                    fontSize="xs"
                  >
                    {visibleHierarchyMcqs.length}/{hierarchyMcqs.length} shown
                  </Badge>
                  <Badge
                    colorScheme="teal"
                    variant="subtle"
                    px={3}
                    py={1}
                    borderRadius="full"
                    fontSize="xs"
                  >
                    {hierarchyMcqTagSummary.length} tags
                  </Badge>
                </HStack>

                {hierarchyMcqTagSummary.length > 0 && (
                  <Wrap spacing={2}>
                    {hierarchyMcqTagSummary.map((tag) => (
                      <WrapItem key={`${tag.name}-${tag.count}`}>
                        <Badge
                          colorScheme="teal"
                          variant="subtle"
                          px={2}
                          py={1}
                          borderRadius="md"
                          fontSize="xs"
                        >
                          {tag.name} ({tag.count})
                        </Badge>
                      </WrapItem>
                    ))}
                  </Wrap>
                )}
              </VStack>
            )}

            {/* Stats */}
            {!hierarchyMcqsLoading && visibleHierarchyMcqs.length > 0 && (
              <SimpleGrid columns={{ base: 2, md: 4 }} spacing={3} pt={1}>
                {[
                  { label: 'Total', value: mcqStats.total, color: accentColor },
                  { label: 'Easy', value: mcqStats.easy, color: 'green.500' },
                  {
                    label: 'Medium',
                    value: mcqStats.medium,
                    color: 'yellow.500',
                  },
                  { label: 'Hard', value: mcqStats.hard, color: 'red.500' },
                ].map((stat) => (
                  <Box
                    key={stat.label}
                    bg={addMcqContainerBg}
                    border="1px solid"
                    borderColor={borderColor}
                    borderRadius="lg"
                    p={3}
                    textAlign="center"
                  >
                    <Text fontSize="xl" fontWeight="700" color={stat.color}>
                      {stat.value}
                    </Text>
                    <Text fontSize="xs" color={secondaryText}>
                      {stat.label}
                    </Text>
                  </Box>
                ))}
              </SimpleGrid>
            )}
          </VStack>
        </CardHeader>

        <CardBody p={{ base: 4, md: 6 }}>
          {hierarchyMcqsLoading ? (
            <Flex justify="center" align="center" minH="40vh">
              <VStack spacing={4}>
                <Spinner
                  thickness="4px"
                  speed="0.65s"
                  emptyColor="gray.200"
                  color={accentColor}
                  size="xl"
                />
                <Text color={secondaryText}>Loading MCQs...</Text>
              </VStack>
            </Flex>
          ) : hierarchyMcqsError ? (
            <Flex
              justify="center"
              align="center"
              minH="30vh"
              direction="column"
              gap={4}
            >
              <Text color="red.400">{hierarchyMcqsError}</Text>
              <Button
                colorScheme="blue"
                variant="outline"
                onClick={fetchHierarchyMcqs}
              >
                Retry
              </Button>
            </Flex>
          ) : hierarchyMcqs.length === 0 ? (
            <Flex
              justify="center"
              align="center"
              minH="30vh"
              direction="column"
              gap={3}
            >
              <Icon as={MdOutlineQuiz} boxSize={12} color="gray.300" />
              <Text color={secondaryText} fontSize="lg">
                No MCQs found for this chapter / topic.
              </Text>
              <Text color={secondaryText} fontSize="sm">
                {selectedSubjectName} › {selectedSubSubjectName} ›{' '}
                {selectedChapterName}
                {selectedTopicName ? ` › ${selectedTopicName}` : ''}
              </Text>
            </Flex>
          ) : visibleHierarchyMcqs.length === 0 ? (
            <Flex
              justify="center"
              align="center"
              minH="30vh"
              direction="column"
              gap={3}
            >
              <Icon as={MdSearch} boxSize={10} color="gray.300" />
              <Text color={secondaryText} fontSize="lg">
                No MCQs match your search.
              </Text>
              <Button
                size="sm"
                variant="outline"
                colorScheme="blue"
                onClick={() => setHierarchyMcqSearch('')}
              >
                Clear Search
              </Button>
            </Flex>
          ) : (
            <VStack spacing={4} align="stretch">
              {visibleHierarchyMcqs.map((mcq, idx) => {
                const isAnswerShown = shownAnswers[mcq._id];
                const diffColor = getDifficultyColor(mcq.difficulty);
                return (
                  <Box
                    key={mcq._id}
                    border="1px solid"
                    borderColor={borderColor}
                    borderRadius="xl"
                    overflow="hidden"
                  >
                    {/* MCQ card header */}
                    <HStack
                      px={4}
                      py={3}
                      bg={hierarchySectionBg}
                      justify="space-between"
                      borderBottom="1px solid"
                      borderColor={borderColor}
                    >
                      <HStack spacing={2}>
                        <Badge
                          colorScheme="purple"
                          variant="outline"
                          fontSize="xs"
                        >
                          Q{idx + 1}
                        </Badge>
                        {mcq.codonId && (
                          <Badge
                            colorScheme="gray"
                            variant="subtle"
                            fontSize="xs"
                            fontFamily="mono"
                          >
                            {mcq.codonId}
                          </Badge>
                        )}
                        {mcq.codonId && (
                          <Tooltip label="Copy MCQ ID">
                            <Button
                              size="xs"
                              variant="ghost"
                              colorScheme="gray"
                              onClick={() => {
                                navigator.clipboard.writeText(mcq.codonId);
                              }}
                              px={1}
                              minW="auto"
                            >
                              📋
                            </Button>
                          </Tooltip>
                        )}
                      </HStack>
                      <HStack spacing={2}>
                        <Badge
                          colorScheme={diffColor}
                          fontSize="xs"
                          textTransform="capitalize"
                        >
                          {mcq.difficulty || 'N/A'}
                        </Badge>
                        <Tooltip label="View full details">
                          <Button
                            size="xs"
                            colorScheme="blue"
                            variant="ghost"
                            onClick={() => openModal(mcq)}
                          >
                            View
                          </Button>
                        </Tooltip>
                        <Tooltip label="Open edit page in new tab">
                          <Button
                            size="xs"
                            colorScheme="orange"
                            variant="ghost"
                            onClick={() => openEditMcqInNewTab(mcq)}
                          >
                            Edit
                          </Button>
                        </Tooltip>
                      </HStack>
                    </HStack>

                    {/* MCQ body */}
                    <Box px={4} py={4}>
                      {/* Question text */}
                      <Text
                        fontSize="sm"
                        fontWeight="500"
                        mb={4}
                        lineHeight="1.7"
                      >
                        {mcq.question?.text || '—'}
                      </Text>
                      {mcq.question?.images?.map((img, i) => (
                        <Image
                          key={i}
                          src={getImageUrl(img)}
                          maxH="180px"
                          mb={3}
                          borderRadius="lg"
                          objectFit="contain"
                          border="1px solid"
                          borderColor={borderColor}
                          p={1}
                        />
                      ))}

                      {/* Options */}
                      <SimpleGrid
                        columns={{ base: 1, md: 2 }}
                        spacing={2}
                        mb={3}
                      >
                        {(mcq.options || []).map((opt, oi) => {
                          const isCorrect =
                            isAnswerShown && oi === mcq.correctAnswer;
                          return (
                            <HStack
                              key={oi}
                              p={3}
                              borderRadius="lg"
                              border="1px solid"
                              borderColor={
                                isCorrect ? 'green.400' : borderColor
                              }
                              bg={
                                isCorrect
                                  ? correctOptionBgColor
                                  : optionBoxDefaultBg
                              }
                              transition="all 0.2s"
                              align="flex-start"
                              spacing={3}
                            >
                              <Box
                                minW="26px"
                                h="26px"
                                borderRadius="md"
                                bg={isCorrect ? 'green.500' : accentColor}
                                color="white"
                                display="flex"
                                alignItems="center"
                                justifyContent="center"
                                fontSize="xs"
                                fontWeight="600"
                                flexShrink={0}
                              >
                                {String.fromCharCode(65 + oi)}
                              </Box>
                              <Text fontSize="sm" flex={1} lineHeight="1.5">
                                {opt.text || opt}
                              </Text>
                              {isCorrect && (
                                <Icon
                                  as={MdCheckCircle}
                                  color="green.500"
                                  boxSize={4}
                                  flexShrink={0}
                                />
                              )}
                            </HStack>
                          );
                        })}
                      </SimpleGrid>

                      {/* Show/Hide answer toggle */}
                      <HStack>
                        <Button
                          size="xs"
                          variant="ghost"
                          colorScheme="purple"
                          onClick={() => toggleAnswer(mcq._id)}
                        >
                          {isAnswerShown ? 'Hide Answer' : 'Show Answer'}
                        </Button>
                        {isAnswerShown && (
                          <Text
                            fontSize="xs"
                            color="green.600"
                            fontWeight="600"
                          >
                            ✓ Correct:{' '}
                            {String.fromCharCode(65 + mcq.correctAnswer)}.{' '}
                            {mcq.options?.[mcq.correctAnswer]?.text ||
                              mcq.options?.[mcq.correctAnswer]}
                          </Text>
                        )}
                      </HStack>

                      {/* Explanation */}
                      {isAnswerShown && mcq.explanation?.text && (
                        <Box
                          mt={3}
                          p={3}
                          bg={explanationBoxBg}
                          borderRadius="lg"
                          border="1px solid"
                          borderColor={explanationBorderColor}
                          fontSize="sm"
                          lineHeight="1.7"
                          dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(mcq.explanation.text),
                          }}
                        />
                      )}
                    </Box>
                  </Box>
                );
              })}
            </VStack>
          )}
        </CardBody>
      </Card>
    );
  };

  // ══════════════════════════════════════════════════════════════════════════
  // SERIAL NO (original behavior preserved)
  // ══════════════════════════════════════════════════════════════════════════
  let serialNo = 1;

  // ══════════════════════════════════════════════════════════════════════════
  // MAIN RENDER
  // ══════════════════════════════════════════════════════════════════════════
  return (
    <Box
      minH="100vh"
      bg={useColorModeValue('gray.50', 'gray.900')}
      pt={{ base: '90px', md: '100px' }}
      pb="12"
      px={{ base: '4', md: '6', lg: '8' }}
    >
      {/* ── ORIGINAL: Back to Tests button ── */}
      <Button
        size="md"
        variant="ghost"
        colorScheme="gray"
        mb={6}
        leftIcon={<MdArrowBack />}
        _hover={{ bg: useColorModeValue('gray.100', 'gray.700') }}
        onClick={() => {
          if (mode === 'regular') {
            navigate('/admin/q-test-list', { state: { refresh: true } });
          } else if (mode === 'exam') {
            navigate('/admin/test-list', { state: { refresh: true } });
          } else {
            navigate('/admin/dashboard');
          }
        }}
      >
        Back to Tests
      </Button>

      {/* ══════════════════════════════════════════════════════════════════ */}
      {/* NEW: EduAdmin Hierarchy Browser — shown above the original card   */}
      {/* Shows browser or MCQ detail page based on hierarchyView state     */}
      {/* ══════════════════════════════════════════════════════════════════ */}
      {hierarchyView === 'browser'
        ? renderHierarchyBrowser()
        : renderHierarchyMCQPage()}

      {/* ══════════════════════════════════════════════════════════════════ */}
      {/* ORIGINAL: Full MCQList Card (100% preserved, nothing removed)     */}
      {/* ══════════════════════════════════════════════════════════════════ */}
      {/* <Card
        bg={bgCard}
        shadow="2xl"
        borderRadius="2xl"
        overflow="hidden"
        border="1px solid"
        borderColor={borderColor}
        maxW="1400px"
        mx="auto"
      > */}
      {/* <CardHeader bg={headerBg} py={8} px={{ base: 6, md: 10 }}>
          <VStack align="stretch" spacing={5}>
            <HStack justify="space-between" align="start" spacing={4}>
              <HStack spacing={4} flex={1}>
                <Icon as={MdOutlineQuiz} boxSize={8} color={accentColor} />
                <VStack align="start" spacing={1}>
                  <Heading size="lg" color={accentColor} lineHeight="tight">
                    {repositoryTitle}
                  </Heading>
                  <Text fontSize="sm" color={secondaryText}>
                    {repositorySubtitle}
                  </Text>
                </VStack>
              </HStack>
              <Badge
                fontSize="lg"
                colorScheme="purple"
                px={5}
                py={2}
                borderRadius="lg"
                whiteSpace="nowrap"
              >
                {totalMcqCount} Questions
              </Badge>
            </HStack>

            {isQTestListPage && !testIdFromList && (
              <Box
                p={4}
                bg={addMcqContainerBg}
                borderRadius="lg"
                border="1px solid"
                borderColor={borderColor}
              >
                <VStack align="stretch" spacing={3}>
                  <Box>
                    <Text fontSize="sm" fontWeight="600" mb={2}>
                      Select Chapter
                    </Text>
                    <HStack spacing={3} align="flex-start">
                      <Box flex="1">
                        <Select
                          placeholder={
                            chaptersLoading
                              ? 'Loading chapters...'
                              : 'All Chapters'
                          }
                          value={selectedChapterId}
                          onChange={(e) => {
                            const nextChapterId = e.target.value;
                            setPage(1);
                            setSelectedChapterId(nextChapterId);
                            if (!nextChapterId) {
                              setTopics([]);
                              setSelectedTopicId('');
                              fetchMcqsTestWise({
                                page: 1,
                                chapterId: '',
                                topicId: '',
                              });
                            }
                          }}
                          bg={addMcqInputBg}
                          size="sm"
                          isDisabled={chaptersLoading}
                        >
                          {chapters.map((chapter) => (
                            <option key={chapter._id} value={chapter._id}>
                              {chapter.name}
                            </option>
                          ))}
                        </Select>
                      </Box>
                      {chaptersError && (
                        <Button
                          size="sm"
                          variant="outline"
                          colorScheme="blue"
                          onClick={fetchChapters}
                        >
                          Retry
                        </Button>
                      )}
                    </HStack>
                    {chaptersError && (
                      <Text fontSize="xs" color="red.400">
                        {chaptersError}
                      </Text>
                    )}
                  </Box>

                  {/* 🔥 TOPIC SELECTOR */}
      {/* {selectedChapterId && (
                    <Box>
                      <Text fontSize="sm" fontWeight="600" mb={2}>
                        Select Topic (Optional)
                      </Text>
                      <Select
                        placeholder={
                          topicsLoading ? 'Loading topics...' : 'All topics'
                        }
                        value={selectedTopicId}
                        onChange={(e) => setSelectedTopicId(e.target.value)}
                        bg={addMcqInputBg}
                        size="sm"
                        isDisabled={topicsLoading}
                      >
                        {topics.map((topic) => (
                          <option key={topic._id} value={topic._id}>
                            {topic.name}
                          </option>
                        ))}
                      </Select>
                    </Box>
                  )} */}

      {/* 🔥 VIEW MCQs BUTTON */}
      {/* {selectedChapterId && (
                    <Button
                      colorScheme="purple"
                      size="sm"
                      isLoading={loading}
                      onClick={fetchMcqsByHierarchy}
                      w="full"
                    >
                      View MCQs by Chapter/Topic
                    </Button>
                  )} */}
      {/* </VStack>
              </Box>
            )} */}

      {/* {isQTestListPage && testIdFromList && (
              <Box
                p={3}
                bg="blue.50"
                border="1px solid"
                borderColor="blue.200"
                borderRadius="md"
              >
                <Text fontSize="sm" color="blue.700">
                  You are viewing MCQs for a specific test. Chapter filtering is
                  not available in this view. To use chapter filters, please
                  open the MCQ list directly from the main route.
                </Text>
              </Box>
            )} */}

      {/* {testIdFromList && (
              <Box
                p={4}
                bg={addMcqContainerBg}
                borderRadius="lg"
                border="1px solid"
                borderColor={borderColor}
              >
                <HStack spacing={3}>
                  <Input
                    placeholder="Enter MCQ Codon ID to add..."
                    value={mcqIdInput}
                    onChange={(e) => setMcqIdInput(e.target.value)}
                    bg={addMcqInputBg}
                    size="sm"
                    borderRadius="md"
                  />
                  <Button
                    colorScheme="green"
                    isLoading={addingMcq}
                    onClick={handleAddMcqToTest}
                    size="sm"
                    minW="fit-content"
                  >
                    Add MCQ
                  </Button>
                </HStack>
              </Box>
            )} */}
      {/* </VStack>
        </CardHeader> */}

      {/* <CardBody p={{ base: 5, md: 8 }}>
          {loading ? (
            <Flex justify="center" align="center" minH="60vh">
              <VStack spacing={4}>
                <Spinner
                  thickness="4px"
                  speed="0.65s"
                  emptyColor="gray.200"
                  color={accentColor}
                  size="xl"
                />
                <Text color={secondaryText}>Loading questions...</Text>
              </VStack>
            </Flex>
          ) : error ? (
            <Flex
              justify="center"
              align="center"
              minH="50vh"
              direction="column"
              gap={4}
            >
              <Text fontSize="lg" color="red.400">
                {error}
              </Text>
              <Button
                colorScheme="blue"
                variant="outline"
                onClick={fetchMcqsTestWise}
              >
                Retry
              </Button>
            </Flex>
          ) : testsWithMcqs.length === 0 ? (
            <Flex
              justify="center"
              align="center"
              minH="50vh"
              direction="column"
              gap={4}
            >
              <Icon as={MdOutlineQuiz} boxSize={16} color="gray.400" />
              <Text fontSize="xl" color={secondaryText}>
                {hasActiveChapterFilter
                  ? 'No MCQs match the selected chapter'
                  : testIdFromList
                    ? 'No MCQs found for this test'
                    : 'No tests with MCQs found'}
              </Text>
              <Button
                size="sm"
                variant="outline"
                colorScheme="blue"
                onClick={() =>
                  navigate(
                    mode === 'regular'
                      ? '/admin/q-test-list'
                      : '/admin/test-list',
                  )
                }
              >
                Back to Tests
              </Button>
            </Flex>
          ) : (
            testsWithMcqs.map((testGroup) => {
              const testKey = testGroup.testId ?? 'manual';
              const mcqsInTest = testGroup.mcqList || [];
              return (
                <Box key={testKey} mb={10}>
                  <Box
                    p={5}
                    bg={headerBg}
                    borderRadius="xl"
                    border="2px solid"
                    borderColor={accentColor}
                    mb={6}
                    cursor="pointer"
                    onClick={() =>
                      setExpandedTestId(
                        expandedTestId === testKey ? null : testKey,
                      )
                    }
                    _hover={{ boxShadow: 'lg', transform: 'translateY(-2px)' }}
                    transition="all 0.3s ease"
                  >
                    <HStack justify="space-between" align="center">
                      <HStack spacing={4}>
                        <Icon
                          as={MdOutlineQuiz}
                          boxSize={8}
                          color={accentColor}
                        />
                        <VStack align="start" spacing={1}>
                          <HStack spacing={3}>
                            <Heading size="md" color={accentColor}>
                              {testGroup.testName ||
                                testGroup.test?.name ||
                                'Manual MCQs'}
                            </Heading>
                            {(testGroup.testId === null ||
                              testKey === 'manual') && (
                              <Badge
                                colorScheme="purple"
                                variant="solid"
                                fontSize="xs"
                              >
                                Manual
                              </Badge>
                            )}
                          </HStack>
                          <Text fontSize="xs" color={secondaryText}>
                            {expandedTestId === testKey
                              ? '▼ Click to collapse'
                              : '▶ Click to expand'}
                          </Text>
                        </VStack>
                      </HStack>
                      <Badge
                        fontSize="lg"
                        colorScheme="purple"
                        px={4}
                        py={2}
                        borderRadius="lg"
                      >
                        {mcqsInTest.length} MCQs
                      </Badge>
                    </HStack>
                  </Box>

                  {expandedTestId === testKey && (
                    <VStack spacing={8} align="stretch" pl={{ base: 0, md: 4 }}>
                      {mcqsInTest.length === 0 ? (
                        <Box
                          p={8}
                          textAlign="center"
                          border="1px dashed"
                          borderColor={borderColor}
                          borderRadius="lg"
                        >
                          <Text color={secondaryText} fontSize="lg">
                            {hasActiveChapterFilter
                              ? 'No MCQs in this test match the selected chapter'
                              : 'No MCQs found for this test'}
                          </Text>
                        </Box>
                      ) : (
                        Object.entries(groupByHierarchy(mcqsInTest))
                          .filter(([_, subSubjectsData]) =>
                            Object.values(subSubjectsData).some((chaps) =>
                              Object.values(chaps).some((tops) =>
                                Object.values(tops).some(
                                  (items) => items.length > 0,
                                ),
                              ),
                            ),
                          )
                          .map(([subject, subSubjectsData]) => (
                            <Box key={subject}>
                              <HStack mb={4}>
                                <Icon
                                  as={MdSchool}
                                  boxSize={6}
                                  color={accentColor}
                                />
                                <Heading size="md" color={accentColor}>
                                  {subject}
                                </Heading>
                              </HStack>
                              <Box
                                border="1px solid"
                                borderColor={borderColor}
                                borderRadius="xl"
                                overflow="hidden"
                                boxShadow="sm"
                              >
                                <Table variant="simple" size="md">
                                  <Thead bg={tableBg}>
                                    <Tr>
                                      <Th>S/No.</Th>
                                      <Th>Sub Subjects</Th>
                                      <Th>Chapter</Th>
                                      <Th>Topic</Th>
                                      <Th>Tags</Th>
                                      <Th>Total Questions</Th>
                                      <Th>Action</Th>
                                    </Tr>
                                  </Thead>
                                  <Tbody>
                                    {Object.entries(subSubjectsData).flatMap(
                                      ([subSubject, chaps]) =>
                                        Object.entries(chaps).flatMap(
                                          ([chapter, tops]) =>
                                            Object.entries(tops)
                                              .filter(
                                                ([, items]) => items.length > 0,
                                              )
                                              .map(([topic, items]) => {
                                                console.log(
                                                  'MCQ items:',
                                                  items,
                                                );
                                                const chapterKey = `${subject}-${subSubject}-${chapter}-${topic}`;
                                                const tags = Array.from(
                                                  new Set(
                                                    items.flatMap(
                                                      (m) => m.tags || [],
                                                    ),
                                                  ),
                                                );
                                                return (
                                                  <React.Fragment
                                                    key={chapterKey}
                                                  >
                                                    <Tr
                                                      _hover={{ bg: bgHover }}
                                                    >
                                                      <Td fontWeight="medium">
                                                        {serialNo++}
                                                      </Td>
                                                      <Td fontWeight="medium">
                                                        {subSubject}
                                                      </Td>
                                                      <Td>{chapter}</Td>
                                                      <Td>{topic}</Td>
                                                      <Td>
                                                        <Wrap>
                                                          {tags.length > 0 ? (
                                                            tags.map(
                                                              (tag, i) => (
                                                                <WrapItem
                                                                  key={i}
                                                                >
                                                                  <Badge
                                                                    colorScheme="teal"
                                                                    variant="subtle"
                                                                    px={2}
                                                                  >
                                                                    {tag}
                                                                  </Badge>
                                                                </WrapItem>
                                                              ),
                                                            )
                                                          ) : (
                                                            <Text
                                                              fontSize="sm"
                                                              color={
                                                                secondaryText
                                                              }
                                                            >
                                                              —
                                                            </Text>
                                                          )}
                                                        </Wrap>
                                                      </Td>
                                                      <Td>
                                                        <Badge
                                                          colorScheme="purple"
                                                          borderRadius="full"
                                                          px={3}
                                                        >
                                                          {items.length}
                                                        </Badge>
                                                      </Td>
                                                      <Td>
                                                        <Button
                                                          size="sm"
                                                          colorScheme="blue"
                                                          variant="solid"
                                                          borderRadius="md"
                                                          boxShadow="sm"
                                                          _hover={{
                                                            boxShadow: 'md',
                                                          }}
                                                          onClick={() =>
                                                            setExpandedChapterKey(
                                                              expandedChapterKey ===
                                                                chapterKey
                                                                ? null
                                                                : chapterKey,
                                                            )
                                                          }
                                                        >
                                                          {expandedChapterKey ===
                                                          chapterKey
                                                            ? 'Hide'
                                                            : 'View Questions'}
                                                        </Button>
                                                      </Td>
                                                    </Tr>

                                                    {expandedChapterKey ===
                                                      chapterKey && (
                                                      <Tr>
                                                        <Td colSpan={6} p={4}>
                                                          <Box
                                                            border="1px solid"
                                                            borderColor={
                                                              borderColor
                                                            }
                                                            borderRadius="xl"
                                                            overflow="hidden"
                                                            boxShadow="sm"
                                                          >
                                                            <Table
                                                              variant="simple"
                                                              size="sm"
                                                            >
                                                              <Thead
                                                                bg={tableBg}
                                                              >
                                                                <Tr>
                                                                  <Th>S/No.</Th>
                                                                  <Th>
                                                                    Question
                                                                  </Th>
                                                                  <Th>
                                                                    Correct
                                                                    Answer
                                                                  </Th>
                                                                  <Th>
                                                                    Difficulty
                                                                  </Th>
                                                                  <Th>Tags</Th>
                                                                  <Th>View</Th>
                                                                  <Th>
                                                                    Delete
                                                                  </Th>
                                                                  <Th>Edit</Th>
                                                                </Tr>
                                                              </Thead>
                                                              <Tbody>
                                                                {items.map(
                                                                  (
                                                                    mcq,
                                                                    index,
                                                                  ) => (
                                                                    <Tr
                                                                      key={
                                                                        mcq._id
                                                                      }
                                                                      _hover={{
                                                                        bg: bgHover,
                                                                      }}
                                                                    >
                                                                      <Td>
                                                                        {index +
                                                                          1}
                                                                      </Td>
                                                                      <Td maxW="420px">
                                                                        <Text
                                                                          noOfLines={
                                                                            2
                                                                          }
                                                                        >
                                                                          {mcq
                                                                            .question
                                                                            ?.text ||
                                                                            '—'}
                                                                        </Text>
                                                                      </Td>
                                                                      <Td
                                                                        color="green.600"
                                                                        fontWeight="semibold"
                                                                      >
                                                                        {mcq
                                                                          .options?.[
                                                                          mcq
                                                                            .correctAnswer
                                                                        ]
                                                                          ?.text ||
                                                                          '—'}
                                                                      </Td>
                                                                      <Td>
                                                                        <Badge
                                                                          colorScheme={getDifficultyColor(
                                                                            mcq.difficulty,
                                                                          )}
                                                                          px={3}
                                                                        >
                                                                          {
                                                                            mcq.difficulty
                                                                          }
                                                                        </Badge>
                                                                      </Td>
                                                                      <Td>
                                                                        <Wrap>
                                                                          {(
                                                                            mcq.tags ||
                                                                            []
                                                                          ).map(
                                                                            (
                                                                              tag,
                                                                              i,
                                                                            ) => (
                                                                              <WrapItem
                                                                                key={
                                                                                  i
                                                                                }
                                                                              >
                                                                                <Badge
                                                                                  colorScheme="teal"
                                                                                  variant="subtle"
                                                                                  px={
                                                                                    2
                                                                                  }
                                                                                >
                                                                                  {
                                                                                    tag
                                                                                  }
                                                                                </Badge>
                                                                              </WrapItem>
                                                                            ),
                                                                          )}
                                                                        </Wrap>
                                                                      </Td>
                                                                      <Td>
                                                                        <Button
                                                                          size="sm"
                                                                          colorScheme="blue"
                                                                          variant="solid"
                                                                          borderRadius="md"
                                                                          boxShadow="sm"
                                                                          _hover={{
                                                                            boxShadow:
                                                                              'md',
                                                                          }}
                                                                          onClick={() =>
                                                                            openModal(
                                                                              mcq,
                                                                            )
                                                                          }
                                                                        >
                                                                          View
                                                                        </Button>
                                                                      </Td>
                                                                      <Td>
                                                                        <Button
                                                                          size="sm"
                                                                          colorScheme="red"
                                                                          variant="outline"
                                                                          borderRadius="md"
                                                                          _hover={{
                                                                            bg: 'red.50',
                                                                          }}
                                                                          onClick={() =>
                                                                            handleDeleteMcq(
                                                                              mcq._id,
                                                                            )
                                                                          }
                                                                        >
                                                                          Delete
                                                                        </Button>
                                                                      </Td>
                                                                      <Td>
                                                                        <Button
                                                                          size="sm"
                                                                          colorScheme="orange"
                                                                          variant="solid"
                                                                          borderRadius="md"
                                                                          boxShadow="sm"
                                                                          _hover={{
                                                                            boxShadow:
                                                                              'md',
                                                                          }}
                                                                          onClick={() =>
                                                                            openEditMcqInNewTab(
                                                                              mcq,
                                                                            )
                                                                          }
                                                                        >
                                                                          Edit
                                                                        </Button>
                                                                      </Td>
                                                                    </Tr>
                                                                  ),
                                                                )}
                                                              </Tbody>
                                                            </Table>
                                                          </Box>
                                                        </Td>
                                                      </Tr>
                                                    )}
                                                  </React.Fragment>
                                                );
                                              }),
                                        ),
                                    )}
                                  </Tbody>
                                </Table>
                              </Box>
                            </Box>
                          ))
                      )}
                    </VStack>
                  )}
                </Box>
              );
            })
          )}
        </CardBody> */}

      {/* ORIGINAL: Pagination Controls */}
      {/* {!loading && testsWithMcqs.length > 0 && totalPages > 1 && (
          <Box
            borderTop="2px solid"
            borderColor={borderColor}
            p={{ base: 6, md: 8 }}
            bg={headerBg}
          >
            <VStack spacing={4}>
              <HStack justify="center" spacing={4} wrap="wrap">
                <Button
                  isDisabled={page === 1}
                  colorScheme="blue"
                  variant="solid"
                  size="md"
                  leftIcon={<MdChevronLeft />}
                  onClick={() => setPage((p) => Math.max(1, p - 1))}
                  _disabled={{ opacity: 0.5, cursor: 'not-allowed' }}
                  boxShadow="sm"
                >
                  Previous
                </Button>

                <HStack
                  spacing={3}
                  px={6}
                  py={3}
                  bg={paginationBoxBg}
                  borderRadius="lg"
                  border="1px solid"
                  borderColor={borderColor}
                  boxShadow="sm"
                >
                  <VStack spacing={0}>
                    <Text fontSize="xs" color={secondaryText}>
                      Page
                    </Text>
                    <Text fontSize="xl" fontWeight="bold" color={accentColor}>
                      {page}
                    </Text>
                  </VStack>
                  <Text fontSize="lg" color={secondaryText}>
                    /
                  </Text>
                  <VStack spacing={0}>
                    <Text fontSize="xs" color={secondaryText}>
                      of
                    </Text>
                    <Text fontSize="xl" fontWeight="bold" color={accentColor}>
                      {totalPages}
                    </Text>
                  </VStack>
                </HStack>

                <Button
                  isDisabled={page === totalPages}
                  colorScheme="blue"
                  variant="solid"
                  size="md"
                  rightIcon={<MdChevronRight />}
                  onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
                  _disabled={{ opacity: 0.5, cursor: 'not-allowed' }}
                  boxShadow="sm"
                >
                  Next
                </Button>
              </HStack>
              <Text fontSize="sm" color={secondaryText} fontStyle="italic">
                {(page - 1) * limit + 1} –{' '}
                {Math.min(page * limit, totalMcqCount)} of {totalMcqCount}{' '}
                questions
              </Text>
            </VStack>
          </Box>
        )}
      </Card> */}

      {/* ── ORIGINAL: Modal (100% preserved) ── */}
      <Modal isOpen={isModalOpen} onClose={closeModal} size="xl" isCentered>
        <ModalOverlay />
        <ModalContent borderRadius="2xl" boxShadow="2xl">
          <ModalHeader
            bg={headerBg}
            py={6}
            px={8}
            borderBottom="1px solid"
            borderColor={borderColor}
          >
            <HStack spacing={3}>
              <Icon as={MdOutlineQuiz} boxSize={6} color={accentColor} />
              <Heading size="md" color={accentColor}>
                Question Details
              </Heading>
            </HStack>
          </ModalHeader>
          <ModalCloseButton mt={4} mr={4} />
          <ModalBody pb={8} pt={6}>
            {selectedMcq && (
              <VStack align="stretch" spacing={6}>
                <Box>
                  <Heading
                    size="md"
                    mb={3}
                    color={accentColor}
                    display="flex"
                    alignItems="center"
                    gap={2}
                  >
                    📝 Question
                  </Heading>
                  <Text lineHeight="1.8">{selectedMcq.question?.text}</Text>
                  {selectedMcq.question?.images?.map((img, i) => (
                    <Image
                      key={i}
                      src={getImageUrl(img)}
                      maxH="220px"
                      mt={4}
                      borderRadius="lg"
                      objectFit="contain"
                      border="1px solid"
                      borderColor={borderColor}
                      p={2}
                    />
                  ))}
                </Box>

                <Divider />

                <Box>
                  <Heading
                    size="md"
                    mb={4}
                    color={accentColor}
                    display="flex"
                    alignItems="center"
                    gap={2}
                  >
                    ✓ Options
                  </Heading>
                  <VStack spacing={3} align="stretch">
                    {selectedMcq.options?.map((opt, i) => (
                      <Box
                        key={i}
                        p={4}
                        borderRadius="lg"
                        border="2px solid"
                        borderColor={
                          selectedMcq.correctAnswer === i
                            ? 'green.500'
                            : borderColor
                        }
                        bg={
                          selectedMcq.correctAnswer === i
                            ? correctOptionBgColor
                            : optionBoxDefaultBg
                        }
                        transition="all 0.2s"
                      >
                        <HStack align="start" gap={4}>
                          <Box
                            minW="32px"
                            h="32px"
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                            bg={
                              selectedMcq.correctAnswer === i
                                ? 'green.500'
                                : accentColor
                            }
                            color="white"
                            borderRadius="md"
                            fontWeight="bold"
                          >
                            {String.fromCharCode(65 + i)}
                          </Box>
                          <Box flex={1}>
                            <Text lineHeight="1.6">{opt.text}</Text>
                            {opt.image && (
                              <Image
                                src={getImageUrl(opt.image)}
                                maxH="140px"
                                mt={3}
                                borderRadius="md"
                                objectFit="contain"
                              />
                            )}
                          </Box>
                          {selectedMcq.correctAnswer === i && (
                            <Icon
                              as={MdCheckCircle}
                              boxSize={6}
                              color="green.500"
                              flexShrink={0}
                            />
                          )}
                        </HStack>
                      </Box>
                    ))}
                  </VStack>
                </Box>

                {(selectedMcq.explanation?.text ||
                  selectedMcq.explanation?.images?.length > 0) && (
                  <Box>
                    <Divider my={2} />
                    <Heading
                      size="md"
                      mt={6}
                      mb={4}
                      color={accentColor}
                      display="flex"
                      alignItems="center"
                      gap={2}
                    >
                      💡 Explanation
                    </Heading>
                    {selectedMcq.explanation?.text && (
                      <Box
                        p={4}
                        bg={explanationBoxBg}
                        borderRadius="lg"
                        border="1px solid"
                        borderColor={explanationBorderColor}
                        lineHeight="1.8"
                        dangerouslySetInnerHTML={{
                          __html: DOMPurify.sanitize(
                            selectedMcq.explanation.text,
                          ),
                        }}
                      />
                    )}
                    {selectedMcq.explanation?.images?.map((img, i) => (
                      <Image
                        key={i}
                        src={getImageUrl(img)}
                        maxH="240px"
                        mt={4}
                        borderRadius="lg"
                        objectFit="contain"
                      />
                    ))}
                  </Box>
                )}
              </VStack>
            )}
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  );
}
